export default {
  routes: {
    // TODO(i18n): French translations pending — English fallback copy below.
    meeting: {
      badge: "Free demo",
      heroTitleLine1: "Let's bring your offer",
      heroTitleLine2: "live.",
      heroDescription:
        "30 minutes, no obligation. We show you the app, dashboard and locking systems for your specific use case.",
      bullets: [
        "Live tour of the platform",
        "Feasibility & locking-system check",
        "A tailored price quote",
      ],
      trustedBy: "Trusted by",
    },
    // TODO(i18n): French translations pending — English fallback copy below.
    team: {
      kicker: "About us",
      heroTitleLine1: "We make sharing",
      heroTitleLine2: "possible for everyone.",
      heroDescription:
        "JUHUU started from a simple idea: one app to find, book and use everything around you — and a platform that makes that effortless for providers.",
      missionKicker: "Our mission",
      missionTitle: "Reimagining the sharing economy.",
      missionText:
        "We integrate and empower existing providers across shared mobility, shared infrastructure and shared tourism — with drastically reduced development cost, less maintenance and faster time-to-market. We don't just take part in the sharing economy; we shape it.",
      valuesKicker: "What drives us",
      valuesTitle: "Clear vision, real solutions.",
      values: [
        {
          title: "Solve real problems",
          description:
            "We don't just talk about the future — we build it. Innovation that works in everyday life.",
        },
        {
          title: "Partnership",
          description:
            "We don't want to be a tool, we want to be a partner. More customers, less effort — that's JUHUU.",
        },
        {
          title: "Sustainability",
          description:
            "Share instead of own. We help people move more sustainably.",
        },
      ],
      awardTitle: "riz up GENIUS Award 2023",
      awardSubtitle: "1st place — category \u201Cregional genius\u201D",
      awardText:
        "Awarded for innovative solutions that solve real problems in a dynamic market.",
      teamKicker: "The team",
      teamTitle: "The people behind JUHUU.",
      members: [
        { initials: "BM", name: "Ben Müller-Niklas", role: "Founder & CEO" },
        { initials: "MW", name: "Moritz Wallner", role: "Product & Engineering" },
        { initials: "MM", name: "Marc Müller-Niklas", role: "Partnerships" },
        {
          initials: "MÜ",
          name: "Michael Übermasser",
          role: "Operations & Support",
        },
      ],
      locationKicker: "Location",
      locationTitleLine1: "From Austria,",
      locationTitleLine2: "for Europe.",
      locationText:
        "JUHUU builds and operates the platform in Austria, with data on EU servers and a focus on the European market.",
      locationCta: "Get to know us",
      locationBadge: "🇦🇹 Österreich",
      finalCtaTitle: "Join the sharing economy.",
      finalCtaDescription:
        "As an operator, manufacturer or partner — let's move things together.",
      finalCtaButton: "Get in touch",
    },
    // TODO(i18n): French translations pending — English fallback copy below.
    references: {
      kicker: "References",
      heroTitleLine1: "Operators who",
      heroTitleLine2: "run on JUHUU.",
      heroDescription:
        "From the train station to the bike shop: operators of every size run their sharing and rental business with JUHUU.",
      stats: [
        { value: "20+", label: "active operators" },
        { value: "< 1", label: "months to live" },
        { value: "14+", label: "languages" },
        { value: "24/7", label: "automated operation" },
      ],
      cases: [
        {
          org: "ÖBB-Personenverkehr AG",
          sub: "Bike:Parking",
          titleLine1: "Secure bike parking",
          titleLine2: "at the station — automated.",
          description:
            "Dozens of weather-protected spots and bike boxes, booked via the app and opened by QR scan. Annual, monthly and daily tariffs are managed entirely through the JUHUU dashboard.",
          stats: [
            { value: "50+", label: "Spots" },
            { value: "24/7", label: "Access" },
            { value: "0", label: "On-site staff" },
          ],
          quote:
            "\u201COur customers book via the JUHUU app and open the box with a QR scan. We see every rental live in the dashboard — with no on-site staff at all.\u201D",
          authorRole: "Project lead",
          authorOrg: "ÖBB Bike:Parking",
          authorInitials: "Ö",
        },
        {
          org: "City of Fellbach",
          sub: "Bike tower at the station",
          titleLine1: "A software takeover",
          titleLine2: "for the bike tower.",
          description:
            "The 16 m bike tower parks up to 76 bikes fully automatically. Its control software originally came from manufacturer Koch & Partner. JUHUU took it over and now runs the whole tower: booking via app, access by QR at one of four gates, plus transit integration through the polygoCard.",
          stats: [
            { value: "76", label: "Spots" },
            { value: "16 m", label: "Tower height" },
            { value: "ÖPNV", label: "polygoCard integration" },
          ],
          quote:
            "\u201COur bike tower ran on the manufacturer's software for years. JUHUU took over the control entirely — today commuters book via the app, and transit-pass holders park for free with their polygoCard.\u201D",
          authorRole: "City of Fellbach",
          authorOrg: "Fellbach.go! radbox",
          authorInitials: "SF",
          transitLabel: "Transit integration:",
          transitText:
            "a stored polygoCard (VVS) = free parking for transit-pass holders.",
        },
        {
          org: "Stadtwerke Osnabrück",
          sub: "Central-station bike hub",
          titleLine1: "Another tower,",
          titleLine2: "centrally controlled.",
          description:
            "At Osnabrück's Altstadt station too, JUHUU controls an automated bike tower and delivers secure parking with no on-site staff. Commuters book via the app.",
          stats: [
            { value: "160", label: "Spots" },
            { value: "24/7", label: "Access" },
          ],
          quote:
            "\u201CAt the station we wanted secure bike parking without staff. With JUHUU we control the tower centrally and see every booking live.\u201D",
          authorRole: "Mobility team",
          authorOrg: "Stadtwerke Osnabrück",
          authorInitials: "OS",
        },
        {
          org: "Allgäutissimo Bikeshop",
          sub: "E-MTB rental",
          titleLine1: "E-bike rental",
          titleLine2: "that runs itself.",
          description:
            "A small bike shop renting premium e-MTBs through bike boxes. With the JUHUU dashboard the team manages rentals, tariffs and deposits. All without an in-house IT team.",
          stats: [
            { value: "+69%", label: "Revenue trend" },
            { value: "7", label: "active tariffs" },
            { value: "4", label: "BikeBoxen" },
          ],
          quote:
            "\u201CWe rent e-MTBs across several bike boxes. Tariffs, bookings and billing run automatically — we take care of the bikes, not the software.\u201D",
          authorRole: "Thorsten Schmitt",
          authorOrg: "Owner, Allgäutissimo Bikeshop",
          authorInitials: "AB",
        },
      ],
      moreKicker: "More operators",
      moreTitle: "In good company.",
      more: [
        {
          name: "Stadt Korneuburg",
          type: "Municipality",
          description:
            "Digital mobility infrastructure for citizens — bike parking and more in one app.",
        },
        {
          name: "BikeBox",
          type: "Hardware partner",
          description:
            "Secure, retrofittable bike boxes, bookable and controllable through JUHUU.",
        },
        {
          name: "NÖ.Regional",
          type: "Regional development",
          description:
            "Regional sharing projects bundled into one platform instead of many silos.",
        },
      ],
      finalCtaTitle: "Become the next operator.",
      finalCtaDescription:
        "In a free demo we'll show you how your business runs with JUHUU.",
      finalCtaButton: "Book a demo",
    },
    // TODO(i18n): French translations pending — English fallback copy below.
    industries: {
      kicker: "Industries",
      heroTitleLine1: "Your offer.",
      heroTitleLine2: "Our platform.",
      heroDescription:
        "Whether secure bike parking or a full rental operation — JUHUU brings your offer into the app and runs it from one dashboard. And if your case is special, we build it together.",
      chipParking: "Bike parking",
      chipRental: "Bike Rental",
      chipCustom: "Other use cases",
      parkingTitle: "Bike parking",
      parkingDescription:
        "Bike boxes and secure rooms at the station, in the city center or at work. Rented automatically, opened by QR scan. With no on-site staff.",
      parkingBullets: [
        "Daily, monthly or long-term rental",
        "Retrofittable locking systems",
        "Live occupancy in the dashboard",
      ],
      parkingStatValue: "50+",
      parkingStatLabel: "secure spots (ÖBB Bike:Parking)",
      parkingStatNote:
        "Weather-protected, monitored, theft-proof opened at the push of a button via the app.",
      rentalTitle: "Bike Rental",
      rentalDescription:
        "From a single bike shop to a fleet: rent bikes and e-bikes flexibly. 24/7 self-service, with precise billing.",
      rentalBullets: [
        "Pay-as-you-go, daily & multi-day tariffs",
        "Hand-over by QR scan or bike box",
        "Your branding in the app",
      ],
      rentalStatValue: "+69%",
      rentalStatLabel: "revenue trend (Allgäutissimo Bikeshop)",
      rentalStatNote:
        "E-MTBs rented across several bike boxes — tariffs, bookings and billing run automatically.",
      customBadge: "Your own use case",
      customTitleLine1: "Your offer doesn't",
      customTitleLine2: "fit a box?",
      customDescription:
        "JUHUU is modular. Almost any smart device or service can be connected — from charging infrastructure to lockers to equipment rental. We build your use case together with you, instead of forcing you into a standard product.",
      customCta: "Discuss your use case",
      customTiles: ["Charging", "Lockers", "Equipment rental", "Your use case"],
      finalCtaTitle: "Let's talk about your case.",
      finalCtaDescription:
        "In a free demo we'll show you how your offer goes live with JUHUU.",
      finalCtaButton: "Book a demo",
    },
    // TODO(i18n): French translations pending — English fallback copy below.
    lockingSystems: {
      heroBadge: "Locking systems · Hardware",
      heroTitleLine1: "Infrastructure,",
      heroTitleHighlight: "controlled by the app",
      heroTitleSuffix: ".",
      heroDescription:
        "The locking system is the bridge between JUHUU and the real world: from the standalone lock through the connected control kit and the JUHUU cloud all the way to the app users unlock with.",
      ctaAdvice: "Request advice",
      ctaSeeKits: "See the kits",
      diagramAlt:
        "JUHUU locking system — from the locking unit through the control kit and the JUHUU cloud to the app",
      sysNodes: [
        {
          title: "Locking unit",
          description:
            "The lock on site, standalone like Tapkey or driven via the relay kit.",
        },
        {
          title: "Control Kit",
          description:
            "Power, internet connection & control unit — the connected core on site.",
        },
        {
          title: "JUHUU cloud",
          description:
            "Secure real-time control — every action is logged and visible in the dashboard.",
        },
        {
          title: "App & web app",
          description: "Users unlock via app, web app, card or terminal.",
        },
      ],
      explainerKicker: "What locking systems are for",
      explainerTitleLine1: "Where software meets",
      explainerTitleLine2: "physical hardware.",
      explainerLead:
        "Through the locking system JUHUU connects the app to real devices on site. You set tariffs and access in the dashboard — unlocking and control happen in real time.",
      explainerCards: [
        {
          title: "Standard solutions",
          description:
            "For common locking mechanisms like sliding doors, boxes, cabinets we have ready-made kits that work out of the box.",
        },
        {
          title: "Relay kit for special cases",
          description:
            "Anything that needs special control is additionally driven via the relay kit on the control kit, almost any device.",
        },
        {
          title: "App & web app control",
          description:
            "End users unlock via app or web app — you keep every action in view, live in the JUHUU dashboard.",
        },
      ],
      kitsKicker: "Our kits",
      kitsTitle: "A kit for every use case.",
      labelUseCase: "UseCase",
      labelPlugAndPlay: "Plug & Play",
      plugAndPlayText:
        "In the standard version ready to go out of the box — plug in and start.",
      kits: [
        {
          badge: "Standalone",
          index: "01 — Tapkey",
          title: "Tapkey lock",
          description:
            "The electronic locking cylinder that runs entirely on its own — battery-powered, no wiring. Just swap the existing cylinder and unlock via app, NFC card or tag.",
          useCase:
            "Doors to bike rooms, collective garages, storage and utility rooms or existing bike boxes. Wherever no wiring is possible and the lock must run on its own.",
          specs: [
            { k: "Type", v: "Electronic locking cylinder (Euro profile)" },
            { k: "Operation", v: "Standalone, battery-powered" },
            { k: "Power", v: "2× lithium CR2, 3.0 V" },
            { k: "Battery life", v: "up to 25,000 cycles / 3 years" },
            { k: "Lengths", v: "40–100 mm (to 180 mm on request)" },
            { k: "Durability", v: "≥ 100,000 cycles (EN 15684 cl. 6)" },
            { k: "Protection", v: "IP66 outer knob · IP65 cylinder" },
            { k: "Temperature", v: "−25 °C … +65 °C" },
            { k: "Access", v: "NFC 13.56 MHz · MIFARE DESFire EV2 (AES-128)" },
            { k: "Operation", v: "Android (BLE & NFC) · iPhone (BLE)" },
            { k: "Certification", v: "EN 15684 · fire resistance T90" },
          ],
        },
        {
          badge: "Control unit",
          index: "02 — Control Kit",
          title: "Control Kit",
          description:
            "The connected core: it establishes the internet connection, runs on mains power and carries the control unit. From here JUHUU controls everything in real time from the cloud — and the relay kits attach to the control kit.",
          useCase:
            "The backbone of every connected site — wherever a location is controlled online. It powers the relay kits and reports every action to the JUHUU cloud.",
          specs: [
            { k: "Type", v: "Control unit / gateway" },
            { k: "Function", v: "Internet link & control" },
            { k: "Connectivity", v: "Mobilfunk (LTE/NB-IoT) · WLAN · Bluetooth" },
            { k: "Power", v: "12–24 V DC (mains)" },
            { k: "Control", v: "JUHUU cloud & dashboard, real time" },
            { k: "Expansion", v: "Relay kits attachable" },
            { k: "Deployment", v: "One unit per site" },
          ],
        },
        {
          badge: "Relay",
          index: "03 — Relay Kit",
          title: "Relay Kit",
          description:
            "The switching kit on the control kit: it drives locks — or anything that can be controlled via a relay. 8 power relays per kit, easily cascaded for larger sites.",
          useCase:
            "Drives locks, barriers, motors, lights and custom hardware — anything that can be switched via a relay.",
          specs: [
            { k: "Type", v: "Relay switching kit" },
            { k: "Power", v: "12–24 V DC (red +, black −)" },
            { k: "Relay channels", v: "8 × with optocouplers & protection" },
            { k: "Relay modules", v: "8 × power relays" },
            { k: "Connections", v: "Screw terminals · NO/COM/NC · data/GND" },
            { k: "Linking", v: "to control kit, cascadable" },
            { k: "Enclosure", v: "Sealed plastic, IP65" },
            { k: "Mounting", v: "Mounting plate, strain relief, cable set" },
          ],
        },
        {
          badge: "Standalone · electronic",
          index: "04 — EMZ",
          title: "EMZ electronics kit",
          description:
            "A fully standalone kit with its own electronic locks — motor-driven, so no manual turning like a cylinder. The standalone alternative to Tapkey when you need electric locks: waterproof, weatherproof and up to 2 years of battery life.",
          useCase:
            "Bike boxes and facilities that need standalone, electric locking — without wiring and without manual closing.",
          specs: [
            { k: "Type", v: "Standalone kit with electronic locks" },
            { k: "Lock", v: "Motor-driven (no manual turning)" },
            { k: "Operation", v: "Standalone, battery-powered" },
            { k: "Battery life", v: "up to 2 years" },
            { k: "Protection", v: "Waterproof & weatherproof" },
            { k: "Access", v: "App · NFC" },
            { k: "Control", v: "Integrated into JUHUU" },
          ],
        },
      ],
      accessoriesKicker: "Add-ons & extensions",
      accessoriesTitle: "More than the lock.",
      accessoriesLead:
        "Around the kits we offer the hardware a professional site needs — from the on-site terminal to occupancy sensors.",
      accessories: [
        {
          title: "On-site terminal",
          description:
            "A weatherproof self-service kiosk for anyone who wants to book without a smartphone: pick a spot or box on the touchscreen, pay contactless (card, Apple Pay, Google Pay) and unlock right away. Connected to the same JUHUU dashboard as the app and web app.",
        },
        {
          title: "Power & solar supply",
          description:
            "Power supplies, battery buffers and solar options for sites without a fixed power connection — so the control and relay kit run reliably off-grid too.",
        },
        {
          title: "RFID & card reader",
          description:
            "Access by NFC/RFID card — for transit cards, employee badges or issued tags. A great alternative to the smartphone at high-traffic sites.",
        },
        {
          title: "Occupancy sensors",
          description:
            "Sensors detect whether a box or spot is free or occupied — availability shows live in the app, web app and dashboard.",
        },
      ],
      dailyKicker: "Built for daily use",
      dailyTitleLine1: "Rugged, retrofittable,",
      dailyTitleLine2: "low-maintenance.",
      dailyDescription:
        "Our locking systems are built for continuous use and retrofit to existing hardware — without a costly replacement.",
      dailyBullets: [
        "App, web app & card access",
        "Retrofits doors, boxes & sliding doors",
        "Weatherproof components for outdoor use",
        "Centrally controlled & logged in the JUHUU dashboard",
      ],
      dailyPhotoPlaceholder: "Drop a photo of on-site use here",
      dailyPhotoAlt: "JUHUU locking systems in everyday use on site",
      finalCtaTitle: "Does it fit your hardware?",
      finalCtaDescription:
        "Send us your use case — we'll check retrofit options and recommend the right kit.",
      finalCtaButton: "Request advice",
    },
    home: {
      // TODO(i18n): French translations pending — English fallback copy below.
      page: {
        heroBadge: "All-in-one sharing platform",
        heroTitle: "The platform for modern",
        heroHighlight: "mobility & infrastructure",
        heroDescription:
          "We digitalize your infrastructure. Connect your smart device, offer it in the JUHUU app and control everything from our dashboard.",
        heroCtaDemo: "Book a demo",
        heroCtaProducts: "See products",
        heroChecks: [
          "Plug & play hardware",
          "Interface & tariffs set up by us",
          "Ready to go out of the box",
        ],
        trustedBy: "Trusted by",
        offerKicker: "What we offer",
        offerTitleLine1: "One toolkit.",
        offerTitleLine2: "For cities and manufacturers.",
        offerDescription:
          "App, web app, booking platform, device control and the matching electronics — from a single source. The complete toolkit to make your infrastructure digital.",
        citiesKicker: "Cities · Municipalities · Public sector",
        citiesTitle: "Digital services for your citizens.",
        citiesDescription:
          "We deliver app, web app and booking platform — including device control and matching electronics. Launch bike parking, rental and shared mobility, but also any other process where your citizens find, book and control something.",
        citiesBullets: [
          "App, web app & booking platform from one source",
          "Device control & matching electronics included",
          "Bike parking, rental, shared mobility & more",
          "Also for bike & scooter sharing with no physical stations at all",
        ],
        manufacturersKicker: "Hardware manufacturers",
        manufacturersTitle: "Your hardware — with JUHUU software.",
        manufacturersDescription:
          "Two ways to make your devices bookable and controllable:",
        manufacturersOptionATitle: "Straight into the JUHUU app",
        manufacturersOptionADescription:
          "Bring your devices into the JUHUU app and sell the software alongside — instantly visible to all existing users.",
        manufacturersOptionBTitle: "Complete whitelabel solution",
        manufacturersOptionBDescription:
          "Get a ready-made whitelabel solution with your hardware connected — JUHUU runs in the background. Sell it under your own brand, ideal for tenders.",
        productsKicker: "Three building blocks for first-class infrastructure",
        productsTitle: "App - Dashboard - Locking systems",
        productsLead:
          "From the physical device to the booking in the app. JUHUU covers the entire process.",
        appDeployCells: [
          {
            tag: "No install",
            title: "WebApp",
            description:
              "The same functionality straight in the browser — ideal for an on-site QR entry, with no store download.",
          },
          {
            tag: "In the JUHUU app",
            title: "JUHUU app",
            description:
              "Your section appears inside the JUHUU app — with your colours, wording, logo & map marker. Instantly visible to existing users.",
          },
          {
            tag: "Own app",
            title: "Whitelabel app",
            description:
              "A fully standalone app in your look — app icon, loading screen, map, buttons and the entire appearance under your brand.",
          },
        ],
        payStripKicker: "All common payment methods · via Stripe",
        includedKicker: "Included in every variant",
        includedItems: [
          "Guest mode — discover the app without an account",
          "Optional identity verification (ID / licence)",
          "14+ languages, one secure checkout",
        ],
        dashboardTitleAlt1: "Your business.",
        dashboardTitleAlt2: "In one cockpit.",
        dashboardLead:
          "Manage devices, set tariffs, automate billing and see in real time what's happening. Predictive maintenance and analytics included — without your own tech team.",
        dashboardBullets: [
          "Real-time monitoring of every device & site",
          "Freely configurable tariffs, per-second billing",
          "Automated invoices straight into your accounting",
          "Your branding: logo & colours in the app",
        ],
        dashboardChips: [
          "Bookings",
          "Devices",
          "Tariffs",
          "Billing",
          "Customers",
          "Benefit cards",
          "Incidents",
        ],
        dashboardCta: "See the dashboard",
        hardwareSpecs: [
          ["IP66", "3 yr battery", "NFC · BLE", "EN 15684"],
          ["LTE · WLAN · BLE", "12–24 V DC", "Real time"],
          ["8 relays", "IP65", "NO/COM/NC"],
          ["Motor-driven", "to 2 yr battery", "Waterproof"],
        ],
        appKicker: "JUHUU App",
        appTitleLine1: "One app.",
        appTitleLine2: "Everything the city shares.",
        appDescription:
          "End users discover, book and unlock devices from many providers, in one intuitive app. Without many hurdles, with transparent pricing and secure payment.",
        appBullets: [
          "Guest mode: find every offer without an account",
          "Scan a QR code to use a service in seconds",
          "Shared mobility, infrastructure & tourism in one platform",
          "14+ languages, one secure checkout",
        ],
        appCta: "Explore the app",
        dashboardKicker: "JUHUU Dashboard",
        dashboardTitleLine1: "Dashboard.",
        dashboardTitleLine2: "Here's what's happening right now.",
        dashboardNavHome: "Home",
        dashboardNavOperators: "Operators",
        dashboardNavBooking: "Booking",
        dashboardNavDevices: "Devices",
        dashboardNavBilling: "Billing",
        dashboardNavSupport: "Support",
        dashboardKpis: [
          { label: "Revenue (7 d)", value: "3.000 €", delta: "▲ 69,4 %" },
          { label: "Rentals", value: "12", delta: "▲ 33,3 %" },
          { label: "Active devices", value: "318", delta: "6 offline" },
          { label: "Utilization", value: "74 %", delta: "avg 7 d" },
        ],
        dashboardIncidents: "Open incidents",
        dashboardIncidentAwaiting: "Awaiting",
        lockingKicker: "Locking systems",
        lockingTagPill: "Hardware",
        lockingTitleLine1: "Smart locks",
        lockingTitleLine2: "that just work.",
        lockingDescription:
          "From bike rooms to lockers: JUHUU locking systems connect the physical world to the app. Scan a QR, unlock, go — wireless, weatherproof and retrofittable to existing hardware.",
        lockingBullets: [
          "QR & Bluetooth access, even offline",
          "Retrofittable, no new infrastructure needed",
          "Weatherproof, monitored, theft-proof",
          "Centrally controlled from the dashboard",
        ],
        lockingCta: "Explore locking systems",
        hardwareItems: [
          {
            name: "Tapkey",
            tag: "Standalone",
            title: "Electronic locking cylinder",
            description:
              "Runs entirely on its own — battery-powered, no wiring. Swap the existing cylinder and unlock via app, NFC card or tag.",
          },
          {
            name: "Control Kit",
            tag: "Control unit",
            title: "Power, internet & control",
            description:
              "The connected core: establishes the internet connection, runs on mains power and controls in real time from the cloud. The relay kits attach here.",
          },
          {
            name: "Relay Kit",
            tag: "Relay",
            title: "Switches (almost) anything",
            description:
              "The switching kit on the control kit: drives locks, barriers, motors, lights and custom hardware — anything switchable via a relay. Cascadable for large sites.",
          },
          {
            name: "EMZ",
            tag: "Standalone · electronic",
            title: "Own electronic locks",
            description:
              "A standalone kit with motor-driven locks — no manual turning. The standalone alternative to Tapkey for electric locks: waterproof with up to 2 years of battery.",
          },
        ],
        stepsKicker: "How simple it is",
        stepsTitleLine1: "Plug & play",
        stepsTitleLine2: "ready in 4 steps.",
        stepsDescription:
          "You buy the locking system from us — we take care of the rest. Consulting, setup and tariffs included, so you launch without your own tech team.",
        steps: [
          {
            title: "Consultation",
            description:
              "We analyse your use case and recommend the right locking system for your site.",
          },
          {
            title: "Plug & play hardware",
            description:
              "You receive the locking system and hardware preconfigured — plug in and done, with zero development.",
          },
          {
            title: "We set it all up",
            description:
              "We configure interface, branding and tariffs for you in the dashboard — tailored to your offer.",
          },
          {
            title: "Ready to go",
            description:
              "Your offer is live in app, web app & dashboard — your customers book and use it easily.",
          },
        ],
        industriesKicker: "Who we build for",
        industriesTitle: "Your industry. Our platform.",
        industries: [
          {
            title: "Bike parking",
            description: "Bike boxes & secure rooms at the station.",
          },
          {
            title: "Bike Rental",
            description: "Rent bikes & e-bikes flexibly, around the clock.",
          },
          {
            title: "Other use cases",
            description: "Your case is special? We'll build it.",
          },
        ],
        pricingKicker: "Pricing",
        pricingTitleLine1: "Enterprise quality.",
        pricingTitleLine2: "For every size.",
        pricingDescription:
          "A platform that grows with you — from a single site to a nationwide network. You only pay for what you use.",
        pricingPoints: [
          "Cancel monthly",
          "No setup fee for standard integrations",
          "Scaling commission instead of fixed-cost traps",
        ],
        pricingCardLabel: "App + Dashboard + locking",
        pricingFrom: "from €149",
        pricingPeriod: "/month for 50 spaces",
        pricingNote:
          "+ a fair commission per booking. Scales with your business.",
        pricingIncludes: [
          "Visibility in the JUHUU app",
          "Full dashboard with analytics",
          "Automated billing & invoicing",
          "Custom branding & interface",
        ],
        pricingCta: "Request a quote",
        pricingBadges: ["Cancel monthly", "GDPR-compliant", "EU servers"],
        faqKicker: "FAQ",
        faqTitle: "Frequently asked.",
        faqs: [
          {
            q: "What exactly is JUHUU?",
            a: "JUHUU is a modular all-in-one platform for the sharing economy. We deliver the full software stack — app, dashboard, billing, support — plus smart locking systems so you can offer any device or service in days instead of months.",
          },
          {
            q: "Do I need to build my own app?",
            a: "No. Your offer appears directly in the JUHUU app and is instantly visible to all existing users. Optionally with your own branding and a custom interface.",
          },
          {
            q: "How long does integration take?",
            a: "Typically under two months. Via no-code templates, low-code configurators or our API we connect devices from many manufacturers — without you needing your own development.",
          },
          {
            q: "Do your locking systems work with my hardware?",
            a: "In most cases, yes. JUHUU locking systems are retrofittable and designed for common doors, boxes and cabinets. We'll check your specific case in the demo call.",
          },
          {
            q: "How does billing work?",
            a: "Fully automated. You set tariffs in the dashboard, JUHUU handles payment and invoicing and can feed it straight into your accounting system.",
          },
          {
            q: "Is JUHUU GDPR-compliant?",
            a: "Yes. All data is processed on EU servers and we comply with GDPR. We're happy to go through the details with you.",
          },
        ],
        finalCtaTitle: "Ready to bring your device online?",
        finalCtaDescription:
          "In a free demo we'll show you how fast your offer goes live in the JUHUU app.",
        finalCtaButton: "Book a free demo",
        finalStats: [
          { value: "< 2", label: "months", sub: "to live" },
          { value: "GDPR", label: "EU servers", sub: "" },
        ],
      },
      heroTitle: "La Plateforme pour une",
      heroHighlight: "Mobilité & Infrastructure Modernes",
      heroDescription:
        "JUHUU est une plateforme modulaire qui aide les entreprises à créer, lancer et développer des solutions numériques pour la mobilité partagée, l'infrastructure intelligente et les services publics—le tout en un seul endroit.",
      getStarted: "Commencer",
      fastDeployment: "Déploiement rapide",
      modularDesign: "Conception modulaire",
      aiEnhanced: "Optimisé par l'IA",
      productCategoriesTitle: "Nos Catégories de Produits",
      productCategoriesDescription:
        "Découvrez notre suite complète de solutions conçues pour répondre aux besoins de votre entreprise",
      emailPlaceholder: "Adresse e-mail",
      dashboardAlt: "Tableau de bord JUHUU",
    },
    app: {
      // TODO(i18n): French translations pending — English fallback copy below.
      heroBadge: "The JUHUU app · For operators",
      heroTitle: "One app for your customers.",
      heroHighlight: "Under your brand.",
      heroDescription:
        "Shared mobility, bike parking and bike rental in one app — native for iOS & Android, as a web app and as a full whitelabel. We integrate almost any bookable offer and ship the matching hardware too.",
      ctaBookDemo: "Book a demo",
      ctaSeeOptions: "See the options",
      platformIosAndroid: "iOS & Android",
      platformWebApp: "WebApp",
      platformWhitelabel: "Whitelabel",
      platform14Languages: "14+ languages",
      heroPhoneAlt: "JUHUU app — map with offers near you",
      // TODO(i18n): French translations pending — English fallback copy below.
      page: {
        deployKicker: "Three ways into the app",
        deployTitle: "How your offer reaches your customers.",
        deployCells: [
          {
            tag: "In the JUHUU app",
            title: "JUHUU app",
            description:
              "Your section appears inside the JUHUU app — with your colours, wording, logo and map marker. Instantly visible to existing users.",
          },
          {
            tag: "Own app",
            title: "Whitelabel app",
            description:
              "A fully standalone app in your look — app icon, loading screen, map, buttons and the entire appearance under your brand.",
          },
          {
            tag: "No install",
            title: "WebApp",
            description:
              "The same functionality straight in the browser — ideal for an on-site QR entry, with no store download.",
          },
        ],
        partialKicker: "Partial whitelabel · in the JUHUU app",
        partialTitleLine1: "Your brand,",
        partialTitleLine2: "inside our app.",
        partialDescription:
          "Your offer lives inside the JUHUU app and is styled to your brand. Users who already have JUHUU find you instantly — with no new app to install.",
        partialBullets: [
          "Interface & button colours",
          "Your own wording & logo",
          "Custom map markers",
          "Custom functions in the background",
        ],
        standaloneKicker: "Whitelabel app · fully standalone",
        standaloneTitleLine1: "Your own app,",
        standaloneTitleLine2: "end to end.",
        standaloneDescription:
          "A fully standalone app in the store — under your name, in your design. We adapt the entire appearance to your brand.",
        standaloneBullets: [
          "Your own app icon",
          "Loading screen on app launch",
          "Map, buttons & overall look",
          "Your own presence on App Store & Google Play",
        ],
        standaloneCtaReferences: "See references",
        featuresKicker: "Included in every variant",
        featuresTitle: "Everything a booking needs.",
        featuresList: [
          {
            title: "All kinds of tariffs",
            description:
              "Pay-as-you-go, daily, monthly and annual tariffs, discounts and gift cards freely combinable.",
          },
          {
            title: "All common payment methods",
            description:
              "From debit and credit card to Apple Pay & Google Pay to PayPal.",
          },
          {
            title: "Identity verification",
            description:
              "Optionally we ask users to confirm their identity via passport, driver's licence or ID card.",
          },
        ],
        paymentsKicker: "Payment methods via Stripe",
        hardwareKicker: "Hardware",
        hardwareTitleLine1: "We offer everything —",
        hardwareTitleLine2: "from autonomous locks to relays.",
        hardwareLead:
          "We offer everything to cover your use case: from ready-made locking systems that run fully autonomously, to setups we drive through our relay boards. And we ship the hardware with it — from the locks to the IoT connectivity.",
        hardwareCards: [
          {
            title: "Ready-made locking systems",
            description:
              "Complete locking systems that run autonomously — doors, boxes, cabinets and sliding doors, retrofit included. We supply the locks and the IoT connectivity too.",
          },
          {
            title: "Integrate new hardware",
            description:
              "Got special devices? We connect new hardware to the platform — via no-code templates, configurators or our API.",
          },
          {
            title: "JUHUU relay board",
            description:
              "Full freedom: with our relay board you decide what gets triggered — barriers, locks, lights, motors or whatever your use case needs.",
          },
        ],
        useCasesKicker: "Use cases",
        useCasesTitle: "Standard use cases — or your own.",
        useCasesDescription:
          "Bike parking, bike rental and shared mobility come as standard. Anything beyond that you build with our standard software & electronics — or fully freely via the relay board.",
        useCaseBikeParking: "Bike parking",
        useCaseBikeRental: "Bike Rental",
        useCaseSharedMobility: "Shared mobility",
        useCaseStandard: "Standard",
        useCaseOwnTitle: "Your own use case",
        useCaseOwnSubtitle: "Software / electronics / relay",
        logosTitle: "Trusted by",
        finalCtaTitle: "Which variant fits you?",
        finalCtaDescription:
          "In a free demo, find out which JUHUU app solution fits your offer best.",
      },
      emailPlaceholder: "Adresse e-mail",
      getStarted: "Commencer",
      fastDeployment: "Déploiement rapide",
      modularDesign: "Conception modulaire",
      aiEnhanced: "Optimisé par l'IA",
      bookingTitle: "Expérience de Réservation Fluide",
      bookingDescription:
        "De la découverte à l'utilisation en quelques clics seulement - voyez comment vos clients peuvent facilement accéder à vos services",
      timeline: {
        scan: "Scanner",
        select: "Sélectionner",
        pay: "Payer",
        use: "Utiliser",
      },
      steps: [
        {
          title: "Scanner le QR-Code",
          desc: "Ouvrez simplement l'application et scannez le code QR pour découvrir les services disponibles près de chez vous.",
        },
        {
          title: "Sélectionner le Tarif",
          desc: "Parcourez les options disponibles et choisissez le plan tarifaire qui correspond le mieux à vos besoins.",
        },
        {
          title: "Payer",
          desc: "Finalisez votre réservation avec un paiement sécurisé en utilisant votre mode de paiement préféré.",
        },
        {
          title: "Utiliser le Produit",
          desc: "Appuyez pour déverrouiller et commencer à utiliser le service immédiatement. Pas besoin de clés ou de cartes.",
        },
      ],
      downloadText: "Téléchargez l'application JUHUU et commencez à explorer dès aujourd'hui",
      featuresTag: "Fonctionnalités",
      featuresTitle: "Plateforme Complète",
      featuresDescription:
        "Notre JUHUU WebApp offre une suite complète d'outils pour gérer les services de mobilité, l'infrastructure et les services publics",
      customInterfaceTag: "Interface Personnalisable",
      customInterfaceTitle: "Votre Marque, Notre Technologie",
      customInterfaceDescription:
        "JUHUU permet aux fournisseurs d'intégrer de manière transparente leur propre identité d'entreprise dans l'application. Maintenez votre identité de marque tout en tirant parti de notre plateforme puissante.",
      becomePartner: "Devenir Partenaire",
      customInterfaces: [
        {
          title: "Image de Marque Personnalisée",
          description:
            "Les fournisseurs peuvent intégrer leur propre logo, couleurs et design dans l'application.",
          features: [
            "Incorporer votre propre logo",
            "Appliquer les couleurs de votre marque",
            "Personnaliser les noms de produits",
            "Expérience de marque cohérente",
          ],
        },
        {
          title: "Tarification Sur Mesure",
          description:
            "Conception de tarifs flexible et catégorisation de produits selon vos besoins.",
          features: [
            "Structures tarifaires personnalisées",
            "Réductions et offres spéciales",
            "Facturation basée sur le temps ou l'utilisation",
            "Options de tarification flexibles",
          ],
        },
        {
          title: "Intégration Fluide",
          description:
            "Intégration complète dans les identités de marque existantes comme ÖBB Bike.",
          features: [
            "Cohérence avec les autres canaux de marque",
            "Interface familière pour les clients",
            "Étiquettes de fonctionnalités personnalisables",
            "Vos propres conditions d'utilisation",
          ],
        },
      ],
      liveDemoTag: "Démo en Direct",
      liveDemoTitle: "Explorez JUHUU en Action",
      liveDemoDescription:
        "Découvrez les emplacements, opérateurs et services disponibles en temps réel. Voyez comme il est facile de trouver et réserver des services de mobilité sur notre réseau en croissance.",
      mapHeading: "Expérience de Carte Interactive",
      mapDescription:
        "Parcourez notre carte interactive pour voir tous les services disponibles dans votre région. Explorez différents opérateurs, emplacements et options de mobilité en un seul endroit.",
      statProviders: "Fournisseurs de services",
      statBookingTime: "Temps de réservation moyen",
      statAvailability: "Disponibilité du service",
      partners: "Déjà en partenariat avec nous",
      joinOperator: "Rejoignez-nous en tant qu'opérateur",
      appStoreAlt: "Télécharger sur l'App Store",
      googlePlayAlt: "Disponible sur Google Play",
      viewCustomInterface: "Voir l'interface personnalisée",
      featuresList: [
        {
          title: "Mobilité",
          description:
            "Solutions de mobilité complètes pour les besoins de transport urbain.",
          benefits: [
            "Intégration fluide avec les transports publics",
            "Suivi en temps réel et notifications",
            "Options de paiement flexibles",
            "Planification de trajets multimodaux",
          ],
        },
        {
          title: "Infrastructure",
          description:
            "Gestion d'infrastructure intelligente pour les villes et les entreprises.",
          benefits: [
            "Systèmes de surveillance compatibles IoT",
            "Maintenance prédictive",
            "Optimisation des ressources",
            "Suivi de l'impact environnemental",
          ],
        },
        {
          title: "Services Publics",
          description:
            "Solutions de gestion de services publics efficaces pour les besoins modernes.",
          benefits: [
            "Intégration de compteurs intelligents",
            "Analyses et insights d'utilisation",
            "Systèmes de facturation automatisés",
            "Optimisation de la consommation",
          ],
        },
        {
          title: "Paiements",
          description:
            "Traitement des paiements sécurisé et flexible pour tous les services.",
          benefits: [
            "Multiples modes de paiement",
            "Gestion des abonnements",
            "Facturation automatisée",
            "Capacités de partage de revenus",
          ],
        },
        {
          title: "Analyses",
          description: "Outils d'analyse puissants pour guider les décisions d'affaires.",
          benefits: [
            "Tableaux de bord en temps réel",
            "Rapports personnalisés",
            "Analyses prédictives",
            "Insights sur le comportement des utilisateurs",
          ],
        },
        {
          title: "Intégration",
          description:
            "Intégration fluide avec les systèmes existants et les services tiers.",
          benefits: [
            "Architecture API ouverte",
            "Connecteurs personnalisés",
            "Compatibilité avec les systèmes legacy",
            "Modules plug-and-play",
          ],
        },
        {
          title: "Sécurité",
          description: "Sécurité de niveau entreprise pour tous les composants de la plateforme.",
          benefits: [
            "Chiffrement de bout en bout",
            "Authentification multi-facteurs",
            "Audits de sécurité réguliers",
            "Conformité aux normes mondiales",
          ],
        },
      ],
    },
    map: {
      heroTitle: "Carte Interactive pour les Services de Mobilité",
      heroDescription:
        "JUHUU Map fournit une solution de cartographie interactive qui affiche les emplacements, la disponibilité et les itinéraires en temps réel pour vos services de mobilité. Intégrez-la n'importe où avec notre intégration iframe flexible.",
      features: {
        realtimeTitle: "Suivi en Temps Réel",
        realtimeDesc: "Emplacements des véhicules et statut de disponibilité en direct",
        integrationTitle: "Intégration Facile",
        integrationDesc: "Intégration iframe simple pour tout site web",
        globalTitle: "Couverture Mondiale",
        globalDesc: "Fonctionne dans le monde entier avec des données cartographiques locales",
        mobileTitle: "Optimisé Mobile",
        mobileDesc: "Design responsive pour tous les appareils",
      },
      liveDemoBadge: "Démo en Direct",
      liveMapTitle: "Carte Interactive en Direct",
      liveMapDescription:
        "Découvrez notre carte interactive en action. C'est la même carte qui alimente les services de mobilité à travers l'Europe.",
      builtForOperatorsTitle: "Conçu pour les Opérateurs",
      builtForOperatorsDescription:
        "Les entreprises utilisant notre plateforme JUHUU peuvent intégrer de manière transparente cette carte interactive dans leur propre site web. Seuls les emplacements et véhicules de l'opérateur respectif sont affichés - parfait pour une expérience client personnalisée.",
      bulletPoints: {
        locationsTitle: "Vos Emplacements Uniquement",
        locationsDesc:
          "La carte affiche exclusivement vos véhicules et stations",
        bookingTitle: "Réservation Directe Disponible",
        bookingDesc:
          "Les clients peuvent réserver directement via la carte intégrée - tout comme via la WebApp JUHUU",
        brandingTitle: "Votre Marque",
        brandingDesc: "Personnalisable pour correspondre à votre design d'entreprise et votre marque",
        operatorTitle: "Optimisé Opérateur",
        operatorDesc:
          "Spécifiquement conçu pour les fournisseurs de services qui souhaitent présenter leurs services de manière professionnelle",
      },
      integrationTitle: "Intégration Simple",
      integrationDescription:
        "Copiez ce code et collez-le dans votre site web pour afficher JUHUU Web App.",
      iframeTitle: "Carte Interactive JUHUU",
    },
    marketplace: {
      heroTitle: "Bienvenue sur le",
      heroHighlight: "JUHUU Marketplace",
      heroDescription:
        "Découvrez et intégrez des solutions spécialisées de nos partenaires de confiance pour améliorer votre plateforme de mobilité. Notre marketplace offre une large gamme de produits conçus pour fonctionner parfaitement avec JUHUU.",
      browseTitle: "Parcourir les Produits",
      browseDescription:
        "Filtrez et recherchez dans notre collection organisée de solutions de mobilité pour trouver ce qui correspond parfaitement à vos besoins.",
      showing: "Affichage",
      of: "sur",
      products: "produits",
      loadMore: "Charger plus",
      loading: "Chargement…",
      noProductsTitle: "Aucun produit trouvé",
      noProductsDescription: "Essayez d'ajuster vos critères de recherche ou de filtre",
      clearFilters: "Effacer tous les filtres",
      close: "Fermer",
      readMore: "En savoir plus",
      productImageAlt: "image du produit",
      ctaTitle: "Prêt à transformer votre entreprise ?",
      ctaSubTitle:
        "Rejoignez des centaines d'entreprises utilisant déjà JUHUU pour créer, lancer et développer leurs solutions de mobilité et d'infrastructure.",
      ctaLaunch: "Lancez votre solution en semaines, pas en mois",
      ctaScale: "Évoluez de manière transparente à mesure que votre entreprise se développe",
      ctaPay: "Ne payez que ce que vous utilisez avec notre approche modulaire",
      ctaStart: "Commencer aujourd'hui",
      ctaFullName: "Nom Complet",
      ctaWorkEmail: "E-mail Professionnel",
      ctaCompany: "Entreprise",
      ctaNamePlaceholder: "Entrez votre nom",
      ctaEmailPlaceholder: "vous@entreprise.com",
      ctaCompanyPlaceholder: "Nom de votre entreprise",
      ctaSubmit: "Contacter les Ventes",
      ctaConsent: "En soumettant ce formulaire, vous acceptez nos",
      ctaTerms: "Conditions d'Utilisation",
      ctaPrivacy: "Politique de Confidentialité",
      ctaAnd: "et",
    },
    billing: {
      heroTitle: "Paiements Unifiés",
      heroHighlight: "& Gestion des Revenus",
      heroDescription:
        "JUHUU Billing est l'infrastructure financière complète qui alimente chaque transaction sur la plateforme JUHUU. Construit sur Stripe Connect, il automatise la capture des paiements, la facturation, la collecte des frais et les versements mensuels—offrant aux opérateurs une source unique et fiable de vérité pour leurs finances.",
      emailPlaceholder: "Adresse e-mail",
      getStarted: "Commencer",
      statusLoading: "Veuillez patienter...",
      statusSent: "Envoyé avec succès !",
      statusError: "Erreur, cliquez pour réessayer.",
      heroBulletPoints: [
        "Capture de paiement instantanée",
        "Facturation automatisée",
        "Versements mensuels",
      ],
      section: {
        logoAlt: "JUHUU Billing",
        title: "Couche unifiée de paiements et de gestion des revenus",
        slogan: "Construit sur Stripe Connect pour des opérations financières fluides",
        description:
          "JUHUU Billing est la couche unifiée de paiements et de gestion des revenus qui alimente chaque transaction sur la plateforme JUHUU. Construit sur Stripe Connect, il automatise la capture des paiements, les autorisations partielles, la génération de factures, la collecte des frais et les versements mensuels—offrant aux opérateurs une source unique et fiable de vérité pour leurs finances.",
        primaryCta: "Commencer",
        secondaryCta: "Voir la documentation",
        features: [
          {
            title: "Capture de paiement instantanée",
            description:
              "Facture automatiquement les clients à chaque confirmation de réservation sur toutes les transactions JUHUU Booking.",
          },
          {
            title: "Autorisation partielle",
            description:
              "Place une retenue de carte initiale pour les locations à l'usage et ne règle que le montant final une fois l'utilisation terminée.",
          },
          {
            title: "Facturation automatisée",
            description:
              "Crée des factures légalement conformes au nom de l'opérateur à la fin de la réservation ou de l'utilisation.",
          },
          {
            title: "Gestion des frais",
            description:
              "Déduit les commissions de transaction JUHUU et les frais mensuels fixes de l'opérateur en temps réel avec une transparence totale.",
          },
          {
            title: "Versements et relevés mensuels",
            description:
              "Consolide tous les paiements, remboursements et frais en un seul versement Stripe avec relevés téléchargeables.",
          },
          {
            title: "Zones Comptables",
            description:
              "Regroupe les revenus par district, ville ou bâtiment pour un reporting granulaire sans modifier la logique de facturation.",
          },
          {
            title: "Remboursements en libre-service",
            description:
              "Émettez des remboursements complets ou partiels directement depuis l'interface opérateur avec synchronisation Stripe automatique.",
          },
          {
            title: "Vue des transactions en temps réel",
            description:
              "Consultez chaque paiement, remboursement, frais et facture dans JUHUU Dashboard pour les opérations quotidiennes et le support.",
          },
        ],
        stats: {
          supportedCurrencies: "Devises Supportées",
          paymentMethods: "Modes de Paiement",
          supportCountries: "Pays Supportés",
        },
      },
      featuresDetail: {
        title: "Infrastructure de Paiement Complète",
        description:
          "Explorez les capacités complètes qui font de JUHUU Billing la solution de paiement la plus robuste pour les opérateurs de mobilité",
        navTitle: "Capacités Clés",
        howItWorks: "Comment ça marche",
        keyBenefits: "Avantages Clés",
        features: [
          {
            title: "Capture de Paiement Instantanée",
            description:
              "Facture automatiquement les clients à chaque confirmation de réservation",
            details: [
              "Traitement automatique des frais lors de la confirmation de réservation",
              "Intégration avec toutes les transactions JUHUU Booking",
              "Mises à jour du statut de paiement en temps réel",
              "Support de multiples modes de paiement",
            ],
            benefits: [
              "Échecs de paiement réduits",
              "Reconnaissance immédiate des revenus",
              "Expérience client fluide",
            ],
          },
          {
            title: "Autorisation Partielle",
            description:
              "Place une retenue de carte initiale pour les locations à l'usage et ne règle que le montant final",
            details: [
              "Retenue de carte initiale pour l'utilisation estimée",
              "Règlement automatique du montant réel",
              "Support pour les produits basés sur l'heure, la minute ou la seconde",
              "Calcul intelligent du montant de retenue",
            ],
            benefits: [
              "Contestations réduites",
              "Tarification équitable pour les clients",
              "Flux de trésorerie optimisé",
            ],
          },
          {
            title: "Facturation Automatisée",
            description:
              "Crée des factures légalement conformes au nom de l'opérateur",
            details: [
              "Génération de factures légalement conformes",
              "Support multilingue",
              "Système de numérotation séquentielle",
              "Rétention de documents sur 10 ans",
            ],
            benefits: [
              "Conformité fiscale garantie",
              "Charge administrative réduite",
              "Communication client professionnelle",
            ],
          },
          {
            title: "Versements et Relevés Mensuels",
            description:
              "Consolide tous les paiements, remboursements et frais en un seul versement Stripe",
            details: [
              "Traitement automatisé des versements mensuels",
              "Relevés complets CSV + PDF",
              "Répartition détaillée par ligne",
              "Notifications par e-mail et accès au tableau de bord",
            ],
            benefits: [
              "Rapprochement simplifié",
              "Transparence financière complète",
              "Processus comptables rationalisés",
            ],
          },
          {
            title: "Zones Comptables",
            description:
              "Regroupe les revenus par district, ville ou bâtiment pour un reporting granulaire",
            details: [
              "Regroupement de centres de coûts virtuels",
              "Reporting au niveau district, ville ou bâtiment",
              "Aucun impact sur la numérotation des factures ou les taux d'imposition",
              "Lecture seule dans les factures pour la conformité",
            ],
            benefits: [
              "Suivi de performance multi-sites",
              "Insights de revenus granulaires",
              "Reporting conforme et sécurisé",
            ],
          },
          {
            title: "Remboursements en Libre-Service",
            description:
              "Émettez des remboursements complets ou partiels directement depuis l'interface opérateur",
            details: [
              "Capacités de remboursement complet et partiel",
              "Synchronisation Stripe automatique",
              "Génération de notes de crédit",
              "Maintien de la piste d'audit",
            ],
            benefits: [
              "Service client plus rapide",
              "Charge de support réduite",
              "Transparence complète des remboursements",
            ],
          },
          {
            title: "Vue des Transactions en Temps Réel",
            description:
              "Consultez chaque paiement, remboursement, frais et facture dans JUHUU Dashboard",
            details: [
              "Surveillance des transactions en direct",
              "Historique complet des paiements",
              "Suivi des factures liées",
              "Mises à jour du statut en temps réel",
            ],
            benefits: [
              "Résolution immédiate des problèmes",
              "Visibilité opérationnelle améliorée",
              "Support client proactif",
            ],
          },
        ],
      },
      paymentFlow: {
        title: "Visualisation du Flux de Paiement",
        description:
          "Voyez comment JUHUU Billing traite les paiements de la réservation à la visibilité dans le tableau de bord en temps réel",
        play: "Lecture",
        pause: "Pause",
        reset: "Réinitialiser",
        steps: [
          {
            title: "Événement de Réservation",
            description:
              "JUHUU Booking envoie une intention de paiement à JUHUU Billing",
            details:
              "Lorsqu'un client confirme une réservation, le système crée automatiquement une intention de paiement avec tous les détails de transaction nécessaires.",
          },
          {
            title: "Capture de Carte",
            description:
              "Stripe traite le paiement ; les fonds arrivent dans le solde de l'opérateur",
            details:
              "Stripe traite le paiement de manière sécurisée et transfère les fonds au solde Stripe de l'opérateur, moins les frais de transaction JUHUU.",
          },
          {
            title: "Autorisation Partielle",
            description: "Pour le paiement à l'usage, JUHUU réserve le montant estimé",
            details:
              "Pour les locations à durée flexible, le système place une retenue pour le coût estimé et la convertit en frais exact lorsque l'utilisation se termine.",
          },
          {
            title: "Génération de Facture",
            description: "Facture PDF créée dans la langue locale du client",
            details:
              "Une facture légalement conforme est automatiquement générée dans la langue du client et archivée dans le compte de l'opérateur.",
          },
          {
            title: "Visibilité dans le Tableau de Bord",
            description:
              "Objet de paiement complet visible immédiatement dans JUHUU Dashboard",
            details:
              "Les informations de paiement complètes, la facture liée et tous les remboursements ultérieurs sont instantanément visibles dans le tableau de bord.",
          },
        ],
        cards: [
          {
            title: "Sécurité d'Abord",
            description:
              "Construit sur l'infrastructure conforme PCI DSS niveau 1 de Stripe avec chiffrement de bout en bout et protection contre la fraude.",
          },
          {
            title: "Échelle Mondiale",
            description:
              "Traitez les paiements avec des modes de paiement locaux et conversion automatique des devises.",
          },
          {
            title: "Surveillance en Temps Réel",
            description:
              "Suivez chaque transaction en temps réel avec journalisation complète et notifications instantanées pour tout problème.",
          },
        ],
      },
      availableNow: "Disponible maintenant",
    },
    docs: {
      heroTitle: "Gestion Intelligente",
      heroHighlight: "des Connaissances",
      heroDescription:
        "JUHUU Docs transforme les connaissances dispersées des opérateurs en une ressource consultable et multilingue. Avec des résumés alimentés par l'IA, des traductions automatiques et une intégration transparente avec JUHUU Buddy, il alimente un support plus rapide et un meilleur libre-service sur l'ensemble de la plateforme JUHUU.",
      emailPlaceholder: "Adresse e-mail",
      getStarted: "Commencer",
      wait: "Veuillez patienter...",
      sent: "Envoyé avec succès !",
      error: "Erreur, cliquez pour réessayer.",
      unlimitedArticles: "Articles illimités",
      languages: "14 langues",
      aiSearch: "Recherche alimentée par l'IA",
      components: {
        section1: {
          heading: "JUHUU Docs",
          description:
            "Transformez les connaissances dispersées en une ressource consultable et multilingue qui alimente un meilleur support et libre-service sur l'ensemble de votre plateforme.",
          articleManagementTitle: "Gestion des Articles",
          articleManagementSubtitle: "Création de contenu illimitée",
          articleManagementDescription:
            "Créez et téléchargez des articles illimités directement depuis JUHUU Dashboard. Maintenez les informations sur les produits, les tarifs et les emplacements toujours à jour avec une publication instantanée.",
          articleManagementItems: [
            "Articles illimités",
            "Publication instantanée",
            "Mises à jour en temps réel",
          ],
          multilingualTitle: "14 Langues",
          multilingualSubtitle: "Traduction alimentée par l'IA",
          multilingualDescription:
            "Chaque article peut être affiché dans l'une des 14 langues d'interface. Les traductions manquantes sont générées à la demande par le service de traduction IA de JUHUU la première fois qu'un utilisateur les demande.",
          multilingualLabels: {
            languages: "Langues",
            languagesDesc: "14+ langues supportées",
            aiTranslation: "Traduction IA",
            aiTranslationDesc: "Zéro surcharge manuelle",
          },
          aiSummariesTitle: "Résumés IA & Aperçus de Liens",
          aiSummariesDescription:
            "Chaque article est résumé automatiquement. Survoler les liens internes affiche le résumé en aperçu pour une navigation plus rapide et un contexte instantané.",
          aiSummariesItems: [
            "Générés automatiquement",
            "Aperçus de liens",
            "Contexte instantané",
          ],
          integratedSearchTitle: "Recherche Intégrée",
          integratedSearchDescription:
            "Recherche en texte intégral et sémantique sur tous les articles, filtrée selon la langue du visiteur. Les utilisateurs et agents de support trouvent la bonne réponse en quelques secondes.",
          integratedSearchItems: [
            "Recherche en texte intégral",
            "Recherche sémantique",
            "Filtrage par langue",
          ],
          supportBridgeTitle: "Pont de Support Client",
          supportBridgeDescription:
            "Lorsque JUHUU Customer Support est activé, tous les articles sont ingérés par JUHUU Buddy afin que le chatbot puisse répondre aux questions des utilisateurs avec des passages cités.",
          supportBridgeItems: [
            "Réduit les tickets",
            "Résolution plus rapide",
            "Réponses cohérentes",
          ],
          cta: "Commencer à Construire Votre Base de Connaissances",
        },
      },
    },
    identity: {
      heroTitle: "Authentification Unique &",
      heroHighlight: "Gestion des Comptes",
      heroDescription:
        "JUHUU Identity est l'épine dorsale de l'authentification unique et de la gestion des comptes de la plateforme JUHUU. Une fois qu'un utilisateur se connecte, chaque interface—JUHUU App, JUHUU Web App, JUHUU Dashboard, JUHUU Docs, JUHUU Marketplace et futurs modules—reconnaît automatiquement cette session.",
      emailPlaceholder: "Adresse e-mail",
      getStarted: "Commencer",
      wait: "Veuillez patienter...",
      sent: "Envoyé avec succès !",
      error: "Erreur, cliquez pour réessayer.",
      badges: {
        universal: "SSO Universel",
        multiTenant: "Identité multi-locataire",
        enterprise: "Sécurité d'entreprise",
      },
      card: {
        title: "Une Identité",
        description: "Accédez à tous les services JUHUU",
        services: [
          "JUHUU App",
          "JUHUU Dashboard",
          "JUHUU Marketplace",
          "JUHUU Docs",
        ],
      },
      capabilities: {
        title: "Capacités Clés",
        description:
          "Gestion d'identité complète qui évolue avec les besoins de votre entreprise",
        items: [
          {
            title: "SSO Universel",
            description: "Un seul compte déverrouille tous les produits JUHUU",
            benefits: "Utilisateurs finaux, opérateurs, fabricants",
          },
          {
            title: "Identité multi-locataire",
            description:
              "Permet aux municipalités ou entreprises de connecter leurs propres fournisseurs OAuth/SAML",
            benefits: "Partenaires municipaux, flottes d'entreprise",
          },
          {
            title: "Authentification flexible",
            description:
              "E-mail + mot de passe, connexion Google, Apple ID ; flux magic-link bientôt disponible",
            benefits: "Intégration sans friction",
          },
          {
            title: "Libre-service de profil",
            description:
              "Les utilisateurs mettent à jour nom, adresse ou numéro de TVA directement dans JUHUU App / Dashboard",
            benefits: "Moins de charge de support",
          },
          {
            title: "Comptes de Gestion",
            description:
              "Portefeuilles partagés qui invitent des membres, paient de manière centralisée et réaffectent les réservations à la volée",
            benefits: "Entreprises, clubs, organismes publics",
          },
        ],
      },
      authentication: {
        title: "Authentification & SSO",
        sections: [
          {
            title: "Authentification JWT Sécurisée",
            description:
              "Un JWT sécurisé émis par JUHUU Identity accompagne chaque appel API, de sorte que les services en aval (par ex. JUHUU Booking, JUHUU Billing) font confiance aux permissions utilisateur sans recherches supplémentaires.",
          },
          {
            title: "Transfert de Session Instantané",
            description:
              "Connectez-vous une fois sur JUHUU App → ouvrez JUHUU Web App et vous êtes déjà authentifié. Aucune connexion multiple requise.",
          },
        ],
        flow: {
          title: "Flux d'Authentification",
          description: "Comment le SSO fonctionne sur les services JUHUU",
          steps: [
            {
              title: "Connexion Utilisateur",
              description: "Se connecter à n'importe quel service JUHUU",
            },
            {
              title: "Émission du Jeton JWT",
              description: "Jeton sécurisé pour tous les services",
            },
            {
              title: "Accès à Tous les Services",
              description: "Expérience fluide partout",
            },
          ],
        },
      },
      accounts: {
        title: "Types de Comptes",
        description:
          "Structures de compte flexibles pour les particuliers et les organisations",
        highlights: "Points forts :",
        types: [
          {
            type: "Compte Personnel",
            holder: "Utilisateurs finaux individuels",
            highlights: [
              "Réservations standard",
              "Modes de paiement enregistrés",
              "Modifications de profil",
            ],
          },
          {
            type: "Compte de Gestion",
            holder: "Entreprises, associations, municipalités",
            highlights: [
              "Ajouter un mode de paiement d'entreprise",
              "Inviter des membres illimités",
              "Réserver des ressources une fois, puis les distribuer aux membres à la demande",
              "Suivre les coûts de manière centralisée",
            ],
          },
        ],
        featuresTitle: "Fonctionnalités des Comptes de Gestion",
        features: [
          {
            title: "Paiement d'Entreprise",
            description: "Facturation et modes de paiement centralisés",
          },
          {
            title: "Gestion des Membres",
            description: "Inviter et gérer des membres d'équipe illimités",
          },
          {
            title: "Suivi de l'Utilisation",
            description: "Surveiller les coûts de manière centralisée",
          },
          {
            title: "Contrôle des Ressources",
            description: "Réserver une fois, distribuer aux membres",
          },
        ],
      },
      security: {
        title: "Pratiques de Sécurité",
        description:
          "Sécurité de niveau entreprise intégrée dans chaque couche de JUHUU Identity",
        items: [
          {
            title: "Sécurité des Mots de Passe",
            description:
              "Les mots de passe sont hachés avec bcrypt 12 et jamais stockés en texte clair.",
          },
          {
            title: "Gestion des Jetons",
            description:
              "Tous les jetons utilisent un accès de courte durée (15 min) et des jetons de rafraîchissement rotatifs.",
          },
          {
            title: "Prévention des Attaques",
            description: "Préventions des attaques par limitation de débit intégrées.",
          },
          {
            title: "Résidence des Données",
            description:
              "La résidence des données est conforme au RGPD de l'UE et aux lois locales de protection des données.",
          },
        ],
        badgeTitle: "Sécurité de Pointe",
        uptime: "SLA de Disponibilité",
        tokenLifetime: "Durée de Vie du Jeton",
        hashRounds: "Tours de Hachage",
        monitoring: "Surveillance",
      },
    },
    digitalTwins: {
      heroTitle: "Hub de Gestion d'Appareils de la",
      heroHighlight: "Plateforme JUHUU",
      heroDescription:
        "JUHUU Digital Twins permet aux opérateurs de représenter chaque actif physique—des trottinettes électriques aux casiers en passant par l'infrastructure complète—comme un jumeau numérique en direct, configurable, qui peut être contrôlé en temps réel et enrichi avec une logique personnalisée.",
      emailPlaceholder: "Adresse e-mail",
      getStarted: "Commencer",
      statusLoading: "Veuillez patienter...",
      statusSent: "Envoyé avec succès !",
      statusError: "Erreur, cliquez pour réessayer.",
      bullets: {
        registry: "Registre et contrôle des appareils",
        automation: "Automatisation par chaînes d'étapes",
        edge: "Exécution en périphérie",
      },
      dashboardSample: {
        title: "Tableau de Bord Jumeau Numérique",
        subtitle: "Contrôle des appareils en temps réel",
        batteryLevel: "Niveau de Batterie",
        doorStatus: "État de la Porte",
        unlockDevice: "Déverrouiller l'Appareil",
      },
      section: {
        title: "Hub de gestion d'appareils de la plateforme JUHUU",
        slogan: "Jumeaux numériques en direct et configurables pour chaque actif physique",
        description:
          "JUHUU Digital Twins permet aux opérateurs de représenter chaque actif physique—des trottinettes électriques aux casiers en passant par l'infrastructure complète—comme un jumeau numérique en direct, configurable, qui peut être contrôlé en temps réel et enrichi avec une logique personnalisée.",
        primaryCta: "Commencer la Gestion des Appareils",
        secondaryCta: "Voir la Documentation",
        badge: "PLATEFORME DE BASE",
        logoAlt: "JUHUU Jumeaux Numériques",
        imageAlt:
          "Tableau de bord JUHUU Digital Twins montrant l'interface de gestion des appareils",
        features: {
          registryTitle: "Registre et contrôle des appareils",
          registryDesc:
            "Crée un enregistrement numérique unique pour chaque matériel, incluant des champs et commandes personnalisés. Centralise la supervision de la flotte et rend les actions à distance accessibles en un clic.",
          automationTitle: "Automatisation par chaînes d'étapes",
          automationDesc:
            "Des 'chaînes d'étapes' en glisser-déposer déclenchent des actions lorsque des événements se produisent. Exécute la logique métier automatiquement, sur le serveur, dans l'App JUHUU, ou directement sur le matériel JUHUU.",
          uiLayoutsTitle: "Mises en page UI spécifiques aux appareils",
          uiLayoutsDesc:
            "L'éditeur visuel crée des boutons et contrôles à l'écran adaptés à chaque appareil. Offre aux utilisateurs finaux une interface intuitive sans écrire de code natif.",
          parameterTitle: "Gestion des paramètres",
          parameterDesc:
            "Les paramètres à l'échelle de la plateforme stockent les états en direct—statut de porte, pression des pneus, et plus—tout en maintenant un historique complet. Permet la surveillance, les tableaux de bord et les analyses en aval.",
          edgeExecutionTitle: "Exécution en périphérie",
          edgeExecutionDesc:
            "La logique des chaînes d'étapes peut être téléchargée sur les kits matériels JUHUU enregistrés et exécutée localement via MQTT, HTTP ou RS-485—même hors ligne.",
        },
        stats: {
          deviceTypes: "Types d'Appareils",
          parametersTracked: "Paramètres Suivis",
          automationRules: "Règles d'Automatisation",
        },
      },
      lifecycle: {
        title: "Gestion du Cycle de Vie des Appareils",
        description:
          "Suivez le parcours complet de l'enregistrement de l'appareil aux analyses intelligentes avec JUHUU Digital Twins",
        play: "Lecture",
        pause: "Pause",
        reset: "Réinitialiser",
        step: "Étape",
        keyActions: "Actions Clés dans cette Étape :",
        steps: [
          {
            title: "Intégrer",
            description: "Enregistrer le nouveau matériel dans JUHUU Dashboard",
            details:
              "Créez des enregistrements numériques pour vos appareils physiques avec des champs de données et définitions de commandes personnalisés.",
            actions: [
              "Enregistrer l'appareil dans Dashboard › Digital Twins",
              "Attribuer des identifiants uniques et des métadonnées",
              "Définir des champs personnalisés et des commandes autorisées",
            ],
          },
          {
            title: "Configurer",
            description:
              "Concevoir des mises en page UI et des chaînes d'étapes avec le constructeur visuel",
            details:
              "Utilisez les outils glisser-déposer pour créer des interfaces personnalisées et des règles d'automatisation pour vos appareils.",
            actions: [
              "Concevoir des mises en page UI spécifiques aux appareils",
              "Créer des chaînes d'étapes avec le constructeur visuel",
              "Définir les paramètres et types de données",
              "Configurer les déclencheurs et règles d'automatisation",
            ],
          },
          {
            title: "Déployer",
            description: "Publier le jumeau ; la logique se synchronise automatiquement",
            details:
              "Déployez votre configuration de jumeau numérique sur le cloud, l'application et les appareils en périphérie de manière transparente.",
            actions: [
              "Publier la configuration du jumeau numérique",
              "Synchroniser la logique avec l'infrastructure cloud",
              "Déployer vers les interfaces JUHUU App",
              "Pousser vers les appareils en périphérie compatibles",
            ],
          },
          {
            title: "Opérer",
            description:
              "Les paramètres en direct se mettent à jour continuellement ; les utilisateurs interagissent via l'UI personnalisée",
            details:
              "Surveillez le statut des appareils en temps réel et activez les interactions utilisateur via vos interfaces personnalisées.",
            actions: [
              "Surveiller les mises à jour de paramètres en direct",
              "Activer les interactions utilisateur via l'UI personnalisée",
              "Exécuter les chaînes d'étapes automatiquement",
              "Gérer les commandes d'appareil en temps réel",
            ],
          },
          {
            title: "Analyser",
            description:
              "Les données historiques de paramètres affluent vers la Détection d'Anomalies IA",
            details:
              "Exploitez les données historiques pour des insights prédictifs et une maintenance proactive des appareils.",
            actions: [
              "Collecter les données historiques de paramètres",
              "Diffuser les données vers la Détection d'Anomalies IA",
              "Générer des insights prédictifs",
              "Configurer les alertes proactives",
            ],
          },
        ],
      },
      parameters: {
        title: "Gestion des Paramètres",
        description:
          "Les paramètres à l'échelle de la plateforme stockent les états en direct tout en maintenant un historique complet pour la surveillance, les tableaux de bord et les analyses en aval",
        supportedTypes: "Types de Données Supportés",
        exampleUsage: "Exemple d'Utilisation :",
        featuresTitle: "Fonctionnalités Clés",
        viewDashboard: "Voir le Tableau de Bord Complet",
        dashboardTitle: "Tableau de Bord des Paramètres en Direct",
        dashboardDescription:
          "Surveillance en temps réel des paramètres d'appareil sur l'ensemble de votre flotte",
        cards: {
          batteryLevel: "Niveau de Batterie",
          doorStatus: "État de la Porte",
          temperature: "Température",
          operationMode: "Mode d'Opération",
          lastUpdated: "Dernière mise à jour : {{time}}",
        },
        types: {
          string: {
            name: "Chaîne",
            description:
              "Paramètres textuels pour les messages de statut, noms d'appareils et descriptions",
            example: "device_status = 'operational'",
          },
          float: {
            name: "Nombre",
            description:
              "Paramètres en nombre décimal pour les mesures précises et calculs",
            example: "tire_pressure = 2.3",
          },
          boolean: {
            name: "Booléen",
            description:
              "Paramètres vrai/faux pour les interrupteurs, verrous et états binaires",
            example: "door_locked = true",
          },
          enum: {
            name: "Enum",
            description:
              "Paramètres de liste prédéfinie pour les modes, états et catégories",
            example: "mode = 'eco' | 'normal' | 'sport'",
          },
        },
        features: {
          visibility: {
            title: "Visibilité Lecture/Écriture",
            description:
              "Les paramètres sont accessibles dans les chaînes d'étapes, mises en page UI et hooks HTTP",
            benefits: [
              "Accès aux données en temps réel sur tous les composants de la plateforme",
              "Intégration transparente avec la logique d'automatisation",
              "Points de terminaison API pour l'intégration système externe",
            ],
          },
          history: {
            title: "Historique Automatique",
            description:
              "Stockage en séries temporelles pour chaque changement de paramètre avec piste d'audit complète",
            benefits: [
              "Rétention complète des données historiques",
              "Analyse de tendances et reconnaissance de motifs",
              "Exigences de conformité et d'audit",
            ],
          },
          analytics: {
            title: "Intégration Analytique",
            description:
              "Flux direct vers les tableaux de bord de Détection d'Anomalies IA pour des insights",
            benefits: [
              "Capacités de maintenance prédictive",
              "Détection d'anomalies et alertes",
              "Insights d'optimisation de performance",
            ],
          },
        },
      },
      quickStart: {
        title: "Guide de Démarrage Rapide",
        description:
          "Lancez votre premier jumeau numérique en moins de 15 minutes avec notre guide étape par étape",
        setupSteps: "Étapes de Configuration",
        progress: "Progression",
        of: "sur {{total}}",
        stepLabel: "Étape {{step}}",
        previous: "Étape Précédente",
        next: "Étape Suivante",
        complete: "Terminer la Configuration",
        whatToDo: "Que faire :",
        proTips: "Conseils Pro :",
        steps: [
          {
            title: "Ajouter un Appareil",
            description:
              "Enregistrez votre premier appareil dans le tableau de bord Digital Twins",
            action:
              "Naviguez vers Dashboard › Digital Twins et cliquez sur 'Ajouter un Nouvel Appareil'",
            tips: [
              "Choisissez un nom d'appareil descriptif pour une identification facile",
              "Sélectionnez la catégorie d'appareil appropriée (trottinette électrique, casier, etc.)",
              "Ajoutez des informations de localisation pour une meilleure gestion de flotte",
            ],
          },
          {
            title: "Définir les Paramètres",
            description:
              "Configurez les champs de données et commandes que votre appareil utilisera",
            action:
              "Définissez les paramètres (battery_level, door_status, etc.) et les commandes autorisées (unlock, lock, etc.)",
            tips: [
              "Commencez par les paramètres essentiels comme le statut et le niveau de batterie",
              "Utilisez des noms de paramètres clairs et descriptifs",
              "Définissez des types de données appropriés pour chaque paramètre",
            ],
          },
          {
            title: "Créer la Mise en Page UI",
            description: "Concevez l'interface utilisateur pour l'interaction avec l'appareil",
            action:
              "Utilisez l'éditeur visuel pour créer des boutons, interrupteurs et indicateurs de statut pour votre appareil",
            tips: [
              "Gardez l'interface simple et intuitive",
              "Groupez les contrôles connexes ensemble",
              "Utilisez la visibilité conditionnelle pour les fonctionnalités avancées",
            ],
          },
          {
            title: "Créer une Chaîne d'Étapes",
            description: "Créez des règles d'automatisation pour le comportement de l'appareil",
            action:
              "Créez au moins une chaîne d'étapes pour définir comment votre appareil répond aux événements",
            tips: [
              "Commencez par des paires déclencheur-action simples",
              "Testez chaque chaîne d'étapes minutieusement",
              "Considérez les cas limites et la gestion des erreurs",
            ],
          },
          {
            title: "Publier & Surveiller",
            description: "Déployez votre jumeau numérique et commencez la surveillance",
            action:
              "Attachez du matériel JUHUU compatible (optionnel), publiez votre configuration et surveillez les données en direct",
            tips: [
              "Surveillez de près les premières interactions",
              "Affinez vos chaînes d'étapes en fonction de l'utilisation réelle",
              "Utilisez les analyses pour optimiser les performances",
            ],
          },
        ],
      },
    },
    dashboard: {
      // TODO(i18n): French translations pending — English fallback copy below.
      page: {
        heroBadge: "JUHUU Dashboard · For operators",
        heroTitleLine1: "Run your whole",
        heroTitleLine2Prefix: "business from",
        heroTitleHighlight: "one place",
        heroDescription:
          "As an operator you control rentals, locations, products, tariffs and billing from a single dashboard — with a real-time view of everything that's happening.",
        ctaBookDemo: "Book a demo",
        ctaLogin: "Log in",
        mockTitle: "Dashboard",
        mockWelcome: "Welcome back! Here's what's happening in your business.",
        navHome: "Home",
        navQuickActions: "Quick Actions",
        navBikeBoxes: "BikeBoxes",
        navCalendar: "Calendar",
        navTransactions: "Transactions",
        navMap: "Map",
        navOperators: "Operators",
        navBooking: "Booking",
        navBilling: "Billing",
        navSupport: "Support",
        kpis: [
          { label: "Revenue (7 days)", value: "3.000 €", delta: "▲ 69,4 %" },
          { label: "Rentals (7 days)", value: "12", delta: "▲ 33,3 %" },
          { label: "Active devices", value: "318", delta: "6 offline" },
          { label: "Utilization", value: "74 %", delta: "avg 7 days" },
        ],
        incidentsTitle: "Open incidents",
        incidentsOverview: "Overview",
        incidentAwaiting: "Awaiting confirmation",
        incidentLow: "Low",
        incidents: [
          { name: "Fahrradbox 3 | E-MTB Hardtail", date: "30.05.2026, 10:40" },
          { name: "Fahrradbox 2 | E-MTB Hardtail", date: "30.05.2026, 10:37" },
          { name: "Fahrradbox 1 | E-MTB Hardtail", date: "28.04.2026, 08:09" },
        ],
        capKicker: "Capabilities",
        capTitleLine1: "One control center.",
        capTitleLine2: "Everything in hand.",
        capLead:
          "Every module you need as an operator, in one interface, with no tool switching.",
        caps: [
          {
            title: "Manage rentals",
            description:
              "Create, export and track bookings and reservations as a timeline or table.",
          },
          {
            title: "Device management",
            description:
              "Track status & history and control hardware remotely — open, lock, reset.",
          },
          {
            title: "Locations, products & QR codes",
            description:
              "Maintain locations and products, issue QR codes and see everything on the map.",
          },
          {
            title: "Tariffs & pay-as-you-go",
            description:
              "Define prices by duration and maximum — from per-minute to annual.",
          },
          {
            title: "Billing & accounting areas",
            description:
              "Review transactions, automate invoices and assign revenue cleanly.",
          },
          {
            title: "Benefit cards & discounts",
            description:
              "Issue discount codes and reduced tariffs and connect external systems like transit.",
          },
          {
            title: "Manage customers",
            description:
              "Search, view and manage customer accounts — including verification status.",
          },
          {
            title: "Monitor incidents",
            description:
              "See open incidents by status and severity and resolve them at once.",
          },
        ],
        bookingKicker: "Booking",
        bookingTitleLine1: "Every rental",
        bookingTitleLine2: "at a glance.",
        bookingDescription:
          "Manage all rental sessions and reservations for your sites — as a timeline or table, filtered by location, colour-coded by status.",
        bookingBullets: [
          "Status: reservation, active, upcoming, pending, completed",
          "Create new rentals manually",
          "Export with one click",
        ],
        mockRentals: "Rentals",
        mockRentalBtn: "Rental",
        chipTimeline: "Timeline",
        chipTable: "Table",
        chipAllLocations: "All locations ▾",
        legendActive: "Active",
        legendUpcoming: "Upcoming",
        legendPending: "Pending",
        timelineLocation: "LOCATION",
        devicesKicker: "Device management",
        devicesTitleLine1: "Your hardware,",
        devicesTitleLine2: "controlled remotely.",
        devicesDescription:
          "Track the status of every device in real time, review its full history and control the hardware right from the dashboard — everything you need to manage your devices.",
        devicesBullets: [
          "Online/offline status & device history",
          "Remote control: open, lock, reset",
          "Register & configure IoT devices",
        ],
        mockDevices: "Devices",
        mockCreateDevice: "Create device",
        mockDevicesLead:
          "Monitor status, view history and control devices remotely.",
        tableName: "Name",
        tableStatus: "Status",
        tableAction: "Action",
        statusOnline: "Online",
        statusOffline: "Offline",
        openBox: "Open box",
        tariffsKicker: "Billing",
        tariffsTitleLine1: "Tariffs you",
        tariffsTitleLine2: "define yourself.",
        tariffsDescription:
          "Define prices by duration and maximum amount — from a pay-as-you-go per-minute tariff to an annual rental. Billing then runs fully automatically.",
        tariffsBullets: [
          "Pay-as-you-go, daily, monthly & annual tariffs",
          "Automatic invoices & transactions",
          "Assignment to accounting areas",
        ],
        mockTariffs: "Tariffs",
        mockCreate: "Create",
        mockTariffsLead: "Set prices for the services you offer.",
        tableDuration: "Duration",
        tableMaxAmount: "Max amount",
        tariffRows: [
          { name: "Pay-as-you-go", duration: "per minute", amount: "0,15 €/min" },
          { name: "Daily rent", duration: "5 min", amount: "25,00 €" },
          { name: "2 Day Rent", duration: "1 day 2 h", amount: "48,00 €" },
          { name: "Annual rent", duration: "365 days", amount: "180,00 €" },
        ],
        customersKicker: "Customers & benefit cards",
        customersTitleLine1: "Your customers.",
        customersTitleLine2: "Your conditions.",
        customersDescription:
          "Manage all customer accounts in one place — and issue benefit cards with discounts or reduced tariffs. This also lets you connect external systems such as public-transport providers and map your own conditions.",
        customersBullets: [
          "Search, view & manage customer accounts",
          "Discount codes & reduced tariffs via benefit cards",
          "Connect external systems like public-transport providers",
        ],
        mockCustomers: "Customers",
        mockUserBtn: "User",
        mockSearchPlaceholder: "Search customers…",
        mockSearchBtn: "Search",
        tableEmail: "E-Mail",
        tableVerified: "Verified",
        customKicker: "Tailored",
        customTitleLine1: "Custom dashboards",
        customTitleLine2: "for every use case.",
        customDescription:
          "We set up custom dashboards that show only what matters, tailored to your use case.",
        customBullets: [
          "Role- & team-specific views",
          "Only the relevant modules — no clutter",
          "Optimised by us for your use case",
        ],
        mockSupportView: "Support view",
        mockCustomBadge: "Custom",
        chipSupport: "Support",
        chipAccounting: "Accounting",
        chipOperations: "Operations",
        customNote: "Only 3 modules visible — reduced to the support use case.",
        customTiles: [
          { label: "Rentals", value: "12", sub: "today" },
          { label: "Customers", value: "1.284", sub: "total" },
          { label: "Devices", value: "318", sub: "online" },
        ],
        recentRentals: "Recent rentals",
        recentRows: [
          { name: "Mara Weiß · BikeBox 04", status: "active" },
          { name: "Tobias Frank · Box 01", status: "pending" },
        ],
        stats: [
          { value: "90%", label: "less admin effort" },
          { value: "24/7", label: "real-time overview" },
          { value: "1", label: "dashboard for everything" },
        ],
        trustedBy: "Trusted by",
        finalCtaTitle: "Get more out of your business.",
        finalCtaDescription:
          "See how operators work with the JUHUU dashboard — or get a personal tour of everything.",
        finalCtaButton: "Book a demo",
      },
      heroTitle: "Tableau de Bord Entreprise",
      heroHighlight: "Analyses & Contrôle.",
      heroDescription:
        "Le tableau de bord complet de JUHUU vous donne un contrôle total sur votre écosystème numérique. Surveillez les performances, gérez les appareils, suivez les finances et optimisez les opérations—le tout depuis une interface unique et intuitive.",
      emailPlaceholder: "Adresse e-mail",
      getStarted: "Commencer",
      realTimeMetrics: "Métriques en temps réel",
      customizableViews: "Vues personnalisables",
      aiPoweredInsights: "Insights alimentés par l'IA",
      billing: {
        tag: "Moteur de Facturation JUHUU",
        title: "Gestion Financière Puissante",
        description:
          "Notre système de facturation complet offre un contrôle total sur vos opérations financières avec des modèles de tarification flexibles, une facturation automatisée et des rapports détaillés.",
        overviewTitle: "Vue d'Ensemble Financière Complète",
        overviewDescription:
          "Obtenez une image complète de vos performances financières avec des insights détaillés sur les flux de revenus, le statut des paiements et les tendances financières.",
        revenueAnalyticsTitle: "Analyses de Revenus",
        revenueAnalyticsDesc:
          "Suivez tous les flux de revenus et identifiez les opportunités de croissance avec des rapports financiers détaillés.",
        paymentTrackingTitle: "Suivi des Paiements",
        paymentTrackingDesc:
          "Surveillez le statut des paiements, les factures et l'historique des transactions en temps réel.",
        financialReportingTitle: "Rapports Financiers",
        financialReportingDesc:
          "Générez des rapports personnalisés et exportez les données financières pour la comptabilité et l'analyse.",
        rentalsTitle: "Gestion des Locations et Réservations",
        rentalsDescription:
          "Surveillez toutes vos locations actives et réservations à venir en temps réel, avec des informations financières détaillées pour chaque transaction.",
        activeRentalTitle: "Suivi des Locations Actives",
        activeRentalDesc:
          "Consultez toutes les locations actives, leur statut et les revenus associés dans un seul tableau de bord.",
        reservationManagementTitle: "Gestion des Réservations",
        reservationManagementDesc:
          "Gérez les réservations à venir, traitez les changements et optimisez l'allocation des ressources.",
        usageStatisticsTitle: "Statistiques d'Utilisation",
        usageStatisticsDesc:
          "Analysez les schémas d'utilisation pour optimiser l'inventaire et améliorer l'expérience client.",
        tariffTitle: "Gestion Flexible des Tarifs",
        tariffDescription:
          "Créez et gérez des modèles de tarification flexibles adaptés aux besoins de votre entreprise, de la facturation basée sur le temps aux plans d'abonnement et tarification dynamique.",
        customPricingTitle: "Modèles de Tarification Personnalisés",
        customPricingDesc:
          "Concevez et mettez en œuvre des structures tarifaires adaptées à vos besoins commerciaux spécifiques.",
        subscriptionManagementTitle: "Gestion des Abonnements",
        subscriptionManagementDesc:
          "Configurez et gérez des plans de facturation récurrents avec facturation automatisée et traitement des paiements.",
        locationSpecificTitle: "Tarifs Spécifiques par Emplacement",
        locationSpecificDesc:
          "Attribuez des tarifs spécifiques à chaque emplacement et appareil individuellement pour une flexibilité maximale.",
        summary:
          "Le Moteur de Facturation JUHUU fournit tous les outils nécessaires pour gérer vos opérations financières de manière efficace et efficiente.",
        learnMore: "En Savoir Plus sur le Moteur de Facturation",
      },
      management: {
        tag: "Tableau de Bord de Gestion",
        title: "Outils de Gestion Puissants",
        description:
          "Prenez le contrôle de votre entreprise avec notre tableau de bord de gestion complet, offrant des insights en temps réel et des outils puissants.",
        realTimeAnalyticsTitle: "Analyses en Temps Réel",
        realTimeAnalyticsDesc:
          "Surveillez les métriques de performance, suivez les schémas d'utilisation et identifiez les opportunités de croissance avec des tableaux de bord analytiques complets.",
        financialManagementTitle: "Gestion Financière",
        financialManagementDesc:
          "Rationalisez la facturation, suivez les flux de revenus et gérez les versements à travers plusieurs unités commerciales ou pays.",
        monthlyRevenue: "Revenus Mensuels",
        activeUsers: "Utilisateurs Actifs",
      },
      device: {
        statusTitle: "Statut des Appareils",
        onlineCount: "{{count}} En Ligne",
        offlineCount: "{{count}} Hors Ligne",
        addDevice: "Ajouter un Appareil",
        table: {
          device: "Appareil",
          status: "Statut",
          lastUsed: "Dernière Utilisation",
          battery: "Batterie",
          location: "Emplacement",
        },
        online: "En Ligne",
        offline: "Hors Ligne",
        oneHourAgo: "Il y a 1 heure",
        tenMinutesAgo: "Il y a 10 minutes",
        thirtyMinutesAgo: "Il y a 30 minutes",
        fiveMinutesAgo: "Il y a 5 minutes",
        acPower: "Alimentation Secteur",
        locationBerlin: "Berlin Centre",
        locationMunich: "Gare de Munich",
        locationHamburg: "Port de Hambourg",
        locationFrankfurt: "Ville de Francfort",
        sectionTag: "Gestion des Appareils",
        sectionTitle: "Rationalisez la gestion des appareils et personnalisez les interfaces",
        sectionDescription:
          "Les opérateurs peuvent accéder aux paramètres clés des appareils, créer des interfaces personnalisées et programmer les appareils à l'aide d'une interface glisser-déposer. Cette section permet également de gérer les cartes SIM et de superviser les connexions de chaque appareil, garantissant des opérations fluides et un contrôle total sur le système.",
        simManagementTitle: "Gestion des SIM",
        simManagementDesc:
          "Gérez les cartes SIM sur vos appareils avec provisionnement et surveillance automatisés.",
        templatesTitle: "Modèles d'Appareils",
        templatesDesc:
          "Créez des interfaces personnalisées et modifiez le code directement avec notre système de modèles intuitif.",
        digitalTwinsTitle: "Jumeaux Numériques",
        digitalTwinsDesc:
          "Obtenez une vue d'ensemble en temps réel de vos appareils avec des répliques numériques qui reflètent le statut physique.",
        connectorsTitle: "Connecteurs",
        connectorsDesc:
          "Gérez la connectivité de votre infrastructure avec nos outils robustes de gestion des connexions.",
      },
      docs: {
        tag: "Gestion des Connaissances",
        title: "JUHUU Docs & Buddy",
        description:
          "Créez, gérez et distribuez les connaissances au sein de votre organisation et à vos clients avec notre système de documentation intelligent et assistant alimenté par l'IA.",
        docsTitle: "JUHUU Docs",
        docsDescription:
          "Créez et gérez une documentation complète pour vos produits, services et FAQ directement depuis votre tableau de bord. Notre système intelligent traduit automatiquement le contenu en plusieurs langues et le rend accessible à vos clients et à JUHUU Buddy.",
        editorTitle: "Éditeur de Documentation",
        multilingualTitle: "Support Multilingue",
        multilingualDesc:
          "La traduction alimentée par l'IA convertit automatiquement votre documentation en plusieurs langues.",
        versionControlTitle: "Contrôle de Version",
        versionControlDesc:
          "Suivez les modifications, gérez les révisions et revenez aux versions précédentes si nécessaire.",
        knowledgeIntegrationTitle: "Intégration de Base de Connaissances",
        knowledgeIntegrationDesc:
          "Connectez de manière transparente votre documentation à JUHUU Buddy pour un support client intelligent.",
        buddyTitle: "JUHUU Buddy",
        buddyDescription:
          "Votre assistant alimenté par l'IA qui exploite votre documentation pour fournir un support instantané et précis à vos clients. JUHUU Buddy apprend de votre base de connaissances et améliore continuellement ses réponses en fonction des interactions clients.",
        buddyConfigTitle: "Configuration de Buddy",
        buddyKnowledgeTitle: "Intégration des Connaissances",
        buddyKnowledgeDesc:
          "Formez votre Buddy avec votre documentation spécifique pour fournir des réponses précises et contextuelles.",
        buddyContinuousTitle: "Apprentissage Continu",
        buddyContinuousDesc:
          "Buddy s'améliore au fil du temps en apprenant des interactions et retours clients.",
        buddyMultilingualTitle: "Support Multilingue",
        buddyMultilingualDesc:
          "Communiquez avec les clients dans leur langue préférée avec traduction en temps réel.",
        ctaText:
          "Donnez du pouvoir à votre équipe et à vos clients avec une documentation intelligente et un support alimenté par l'IA qui s'améliore continuellement.",
        exploreBuddy: "Explorer JUHUU Buddy",
        exploreDocs: "Explorer JUHUU Docs",
      },
    },
    designYourOwn: {
      heroTitle: "Concevez Votre Propre",
      heroHighlight: "Cas d'Usage",
      heroDescription:
        "Avec notre système de blocs de construction modulaires, numérisez n'importe quelle idée en quelques jours seulement — du partage de vélos et trottinettes aux plateformes de stationnement intelligent. Pas besoin de mois de développement personnalisé.",
      emailPlaceholder: "Adresse e-mail",
      getStarted: "Commencer",
      badges: {
        fastDeployment: "Déploiement rapide",
        modularDesign: "Conception modulaire",
        aiEnhanced: "Optimisé par l'IA",
      },
      cardTitles: {
        modularDesign: "Conception Modulaire",
        rapidIntegration: "Intégration Rapide",
        timeToMarket: "Délai de Mise sur le Marché",
        provenSolution: "Solution Éprouvée",
        fasterLaunch: "Lancement sur le marché jusqu'à 70% plus rapide",
      },
      introTitle: "Votre Cas d'Usage Personnalisé — Mis en Œuvre en un Temps Record",
      introDescription:
        "JUHUU vous offre la flexibilité de concevoir votre propre solution de mobilité sans repartir de zéro. Exploitez nos modules éprouvés et économisez un temps de développement précieux avec notre intégration plug-and-play.",
      features: {
        modularBlocksTitle: "Blocs de Construction Modulaires",
        modularBlocksDesc:
          "Choisissez exactement les fonctions dont vous avez besoin. De la gestion des utilisateurs au traitement des paiements en passant par l'intégration IoT — le tout avec de simples connexions API.",
        seamlessIntegrationTitle: "Intégration Transparente",
        seamlessIntegrationDesc:
          "Grâce aux API et SDK standardisés, vous pouvez intégrer votre matériel et vos systèmes en un minimum de temps avec nos connecteurs en un clic.",
        whiteLabelTitle: "Solution en Marque Blanche",
        whiteLabelDesc:
          "Personnalisez entièrement l'apparence pour correspondre à votre marque — de l'application aux interfaces de support client avec notre système de conception intuitif.",
      },
      integration: {
        title: "Intégration Simplifiée",
        description:
          "Notre plateforme est conçue pour une intégration transparente avec vos systèmes et matériels existants. Connectez en minutes, pas en mois.",
        list: {
          oneClickTitle: "Intégration d'Appareils en Un Clic",
          oneClickDesc: "Ajoutez de nouveaux appareils à votre flotte avec un simple scan",
          preBuiltTitle: "Connecteurs API Préfabriqués",
          preBuiltDesc: "Intégrations prêtes à l'emploi pour les services populaires",
          noCodeTitle: "Configuration Sans Code",
          noCodeDesc: "Configurez des flux de travail complexes sans programmation",
        },
        statusTitle: "Statut d'Intégration",
        statusDesc: "Tous les systèmes connectés",
        active: "Actif",
        items: {
          paymentGateway: "Passerelle de Paiement",
          mobileApp: "Application Mobile",
          securityModule: "Module de Sécurité",
          userManagement: "Gestion des Utilisateurs",
          connected: "Connecté",
        },
        addButton: "Ajouter une Nouvelle Intégration",
      },
      process: {
        title: "Votre Cas d'Usage Personnalisé en 4 Étapes Simples",
        step1Title: "Définir l'Idée & les Objectifs",
        step1Desc:
          "Menez des entretiens avec vos groupes cibles, documentez les points de douleur et formulez votre énoncé de cas d'usage. Notre équipe vous aidera à affiner vos besoins.",
        step1Tags: [
          "Analyse des Besoins",
          "Définition du Groupe Cible",
          "Analyse de Marché",
        ],
        step2Title: "Sélectionner les Modules",
        step2Desc:
          "Choisissez exactement les composants dont vous avez besoin dans notre boîte à outils technologique modulaire. Des applications utilisateur aux tableaux de bord opérateur en passant par l'intégration IoT et le traitement des paiements.",
        step2Tags: [
          "Sélection de Modules",
          "Spécification Technique",
          "Planification d'Architecture",
        ],
        step3Title: "Mise en Œuvre",
        step3Desc:
          "Intégrez le matériel, configurez le tableau de bord et personnalisez l'image de marque frontend. Notre équipe d'experts vous guidera tout au long du processus avec nos outils d'intégration en un clic.",
        step3Tags: [
          "Intégration Matérielle",
          "Image de Marque",
          "Configuration",
          "Tests",
        ],
        step4Title: "Pilote & Déploiement",
        step4Desc:
          "Commencez avec une petite flotte, recueillez des retours, puis élargissez votre déploiement. Notre plateforme évolue avec vos besoins et s'adapte à vos exigences changeantes.",
        step4Tags: [
          "Projet Pilote",
          "Analyse des Retours",
          "Mise à l'Échelle",
          "Optimisation Continue",
        ],
      },
      ecosystem: {
        title: "Écosystème de Produits JUHUU",
        description:
          "Notre suite complète de produits fonctionne ensemble de manière transparente pour alimenter votre cas d'usage personnalisé",
        coreTitle: "Infrastructure de Base",
        core: {
          digitalTwinsTitle: "Jumeaux Numériques",
          digitalTwinsDesc: "Réplications virtuelles de tous vos appareils physiques",
          identityTitle: "Identity",
          identityDesc: "Authentification sécurisée et gestion des utilisateurs",
          specialDevTitle: "Développement Spécialisé",
          specialDevDesc: "Services d'intégration personnalisés pour cas d'usage complexes",
          strataTitle: "Strata",
          strataDesc: "Plateforme d'intégration en libre-service",
          comingSoon: "Prochainement",
        },
        uiTitle: "Interfaces Utilisateur",
        ui: {
          appTitle: "App",
          appDesc: "Applications mobiles natives pour iOS et Android",
          webAppTitle: "WebApp",
          webAppDesc: "Interface de réservation et de gestion basée sur navigateur",
          mapTitle: "Map",
          mapDesc: "Services interactifs basés sur la localisation et visualisation",
          whitelabelTitle: "Whitelabel",
          whitelabelDesc: "Applications personnalisées entièrement sous votre marque",
        },
        opsTitle: "Opérations & Business",
        ops: {
          dashboardTitle: "Dashboard",
          dashboardDesc: "Console de gestion et d'analyse complète",
          billingTitle: "Billing",
          billingDesc: "Traitement des paiements, facturation et gestion financière",
          marketplaceTitle: "Marketplace",
          marketplaceDesc:
            "Découvrez et intégrez du matériel et des services certifiés",
          buddyTitle: "Buddy",
          buddyDesc: "Support et assistance alimentés par l'IA",
        },
      },
      productsTogetherTitle: "Comment Nos Produits Fonctionnent Ensemble",
      todayTitle: "Aujourd'hui : Développement Spécialisé",
      todayDesc:
        "Actuellement, nous travaillons directement avec les clients pour mettre en œuvre leurs cas d'usage personnalisés via notre service de Développement Spécialisé. Notre équipe d'experts gère l'intégration de vos systèmes avec notre plateforme.",
      todayBenefitsTitle: "Avantages :",
      todayBenefits: [
        "Solutions entièrement personnalisées",
        "Guidance experte tout au long du processus",
        "Mise en œuvre rapide avec notre équipe expérimentée",
      ],
      futureTitle: "Futur : Plateforme Strata",
      futureDesc:
        "Bientôt, notre plateforme Strata vous permettra de mettre en œuvre vos propres cas d'usage sans notre implication directe. Vous pourrez choisir parmi des parcours d'intégration sans code, low-code ou expert selon vos besoins.",
      futureBenefitsTitle: "Avantages :",
      futureBenefits: [
        "Intégration en libre-service",
        "Options sans code, low-code et expert",
        "Contrôle total sur votre mise en œuvre",
      ],
      uspTitle: "Pourquoi Choisir JUHUU",
      usps: {
        speedTitle: "Rapidité & Évolutivité",
        speed1:
          "Intégration Plug-and-Play : Déployez des appareils certifiés en quelques jours via des parcours d'intégration Sans Code, Low-Code et Expert",
        speed2:
          "Blocs de Croissance Modulaires : Chaque nouveau produit repose sur la même fondation, garantissant zéro complexité supplémentaire lors de votre expansion",
        flexibilityTitle: "Flexibilité & Contrôle",
        flexibility1:
          "Trois Niveaux d'Intégration : Choisissez votre niveau d'effort—clé en main pour un minimum d'efforts, configurateurs visuels pour des ajustements rapides, ou API profondes pour une logique personnalisée",
        flexibility2:
          "Image de Marque Blanche : Opérez au sein de l'App JUHUU universelle ou créez une coque Whitelabel entièrement privée",
        growthTitle: "Croissance & Monétisation",
        growth1:
          "Incitations Opérateur : Partage de Revenus (15%) et programmes de Parrainage d'Utilisateurs transforment les partenaires en marketeurs",
        growth2:
          "Extensions à Forte Marge : Abonnements Plus, Liens d'Affiliation et Services Réservables Intégrés débloquent de nouveaux flux de revenus",
        efficiencyTitle: "Efficacité Opérationnelle",
        efficiency1:
          "Flux de Bout en Bout : Des données d'appareil via le Moteur de Facturation, Identity et Dashboard, chaque point de contact partage un modèle de données unifié",
        efficiency2:
          "Maintenance Prédictive : La Détection d'Anomalies signale les pannes tôt, réduisant les temps d'arrêt imprévus jusqu'à 30%",
      },
      components: {
        appDescription: {
          heading: "Une Plateforme, Solutions Multiples",
          description:
            "JUHUU connecte les utilisateurs aux fournisseurs de services via une plateforme transparente et intégrée pour la mobilité, l'infrastructure et les services publics.",
          forUsers: {
            title: "Pour les Utilisateurs",
            description:
              "Trouvez, réservez et utilisez des services de différents fournisseurs en un seul endroit. JUHUU rassemble une large gamme de services de mobilité, d'infrastructure et de services publics dans une application unique et facile à utiliser.",
            features: [
              {
                title: "Découverte de Services",
                description: "Trouvez des services à proximité avec disponibilité en temps réel",
              },
              {
                title: "Paiements Faciles",
                description: "Réservez et payez de manière transparente dans l'application",
              },
              {
                title: "Accès Unifié",
                description:
                  "Accédez aux services de plusieurs fournisseurs avec un seul compte",
              },
              {
                title: "Couverture Mondiale",
                description:
                  "Utilisez la même application dans plusieurs villes et pays",
              },
            ],
          },
          forProviders: {
            title: "Pour les Fournisseurs",
            description:
              "Atteignez plus de clients et rationalisez vos opérations. JUHUU donne aux fournisseurs de services les outils dont ils ont besoin pour offrir leurs produits et services à un public plus large.",
            features: [
              {
                title: "Large Base d'Utilisateurs",
                description: "Accès à une communauté croissante d'utilisateurs actifs",
              },
              {
                title: "Canal de Vente",
                description:
                  "Canal de distribution direct pour tous vos services",
              },
              {
                title: "Whitelabeling",
                description: "Intégration de l'identité d'entreprise dans l'application",
              },
              {
                title: "Services JUHUU",
                description:
                  "Accès direct aux services JUHUU profondément intégrés",
              },
            ],
          },
          cta: "Commencer avec JUHUU",
        },
      },
    },
    bikeSharing: {
      heroTitle: "Cas d'Usage Partage de Vélos",
      backToOverview: "\u2190 Retour à l'aperçu",
      intro:
        "Lancez et gérez un service complet de partage de vélos avec notre solution de bout en bout. JUHUU fournit tout ce dont vous avez besoin : applications utilisateur, tableaux de bord opérateur et traitement des paiements.",
      underConstructionTitle: "Cette page est en construction",
      underConstructionText:
        "Des informations détaillées sur le cas d'usage de partage de vélos seront bientôt disponibles.",
    },
    bikeParking: {
      heroTitle: "Stationnement à Vélos Intelligent",
    },
    webApp: {
      heroTitle: "Écosystèmes Numériques",
      heroHighlight: "Dans Votre Navigateur",
      components: {
        showCase: {
          features: {
            billing: {
              title: "Facturation",
              subtitle: "Système de paiement intégré pour des transactions fluides",
              description:
                "Le module de Facturation au sein de l'App JUHUU permet aux utilisateurs d'effectuer des paiements et de sélectionner des tarifs sans effort. Les opérateurs bénéficient d'une infrastructure de paiement complète qui gère les abonnements, les paiements uniques et la facturation récurrente sans développement supplémentaire. Cette solution intégrée réduit la charge administrative pour les opérateurs tout en offrant aux utilisateurs une expérience de paiement fluide directement dans l'application.",
              bullets: [
                "Réduisez les coûts opérationnels avec le traitement automatisé des paiements",
                "Augmentez les revenus avec des modèles de tarification flexibles pour les opérateurs",
                "Obtenez des insights grâce à des analyses financières complètes",
              ],
            },
            identity: {
              title: "Identity",
              subtitle: "Système d'authentification et de vérification sécurisé",
              description:
                "Le module Identity dans l'App JUHUU fournit aux utilisateurs des options de connexion sécurisées tout en donnant aux opérateurs des capacités de vérification flexibles. Les opérateurs peuvent demander une vérification d'identité en cas de besoin pour leurs services, améliorant la sécurité et la conformité. Ce système de gestion d'identité entièrement intégré simplifie l'intégration des utilisateurs tout en protégeant les opérateurs et les utilisateurs contre la fraude et l'accès non autorisé.",
              bullets: [
                "Réduisez la fraude et l'accès non autorisé pour les services des opérateurs",
                "Simplifiez la vérification des utilisateurs et les exigences de conformité",
                "Renforcez la confiance des clients avec une sécurité de niveau entreprise",
              ],
            },
            map: {
              title: "Carte",
              subtitle: "Découverte complète de produits et services",
              description:
                "La fonctionnalité Carte dans l'App JUHUU affiche tous les produits et services de chaque fournisseur dans une interface unifiée. Cela donne aux utilisateurs un aperçu complet des options disponibles à proximité, augmentant la visibilité pour les opérateurs. En s'intégrant au module Carte, les opérateurs gagnent une exposition immédiate aux utilisateurs recherchant des services comme les leurs, sans avoir besoin de construire leur propre plateforme de découverte.",
              bullets: [
                "Augmentez la visibilité pour les opérateurs en montrant les services aux utilisateurs à proximité",
                "Élargissez la portée client sans construire une plateforme de découverte séparée",
                "Bénéficiez de l'acquisition d'utilisateurs basée sur la localisation de JUHUU",
              ],
            },
            buddy: {
              title: "JUHUU Buddy",
              subtitle: "Assistant IA multilingue pour utilisateurs et opérateurs",
              description:
                "JUHUU Buddy est un assistant IA intégré disponible directement dans l'App JUHUU, capable de répondre aux questions sur l'application elle-même et sur les services offerts par les opérateurs. Disponible en 14 langues, il fournit un support 24/7 sans exiger des opérateurs qu'ils construisent leur propre infrastructure de support. Cette ressource partagée profite à tous les opérateurs sur la plateforme tout en améliorant l'expérience utilisateur.",
              bullets: [
                "Réduisez les coûts de support client jusqu'à 60% pour les opérateurs",
                "Évoluez les opérations sans augmenter proportionnellement le personnel de support",
                "Améliorez la satisfaction client avec une assistance instantanée et multilingue",
              ],
            },
            integratedBookables: {
              title: "Services Réservables Intégrés",
              subtitle: "Services pré-intégrés qui améliorent l'expérience utilisateur",
              description:
                "JUHUU a déjà intégré des services clés comme les stations de recharge (via Hubject) à nos propres frais, les rendant directement réservables dans l'application. Ces Services Réservables Intégrés rendent l'App JUHUU plus attractive pour les utilisateurs tout en fournissant aux opérateurs un écosystème plus riche. En rejoignant la plateforme, les opérateurs bénéficient de ces intégrations préexistantes et de la base d'utilisateurs accrue qu'elles attirent.",
              bullets: [
                "Exploitez les intégrations préexistantes comme les stations de recharge Hubject",
                "Bénéficiez de l'investissement de JUHUU dans les connexions de services tiers",
                "Rejoignez un écosystème avec une demande utilisateur établie pour les services intégrés",
              ],
            },
          },
          learnMore: "En Savoir Plus",
          contactSales: "Contacter les Ventes",
        },
        compatibility: {
          badge: "Disponible Partout",
          heading: "Accédez à JUHUU depuis N'importe quel Appareil ou Navigateur",
          description:
            "Notre plateforme web est conçue pour fonctionner de manière transparente sur tous les navigateurs et appareils modernes, vous permettant de gérer vos services de mobilité depuis n'importe où.",
          browserHeading: "Compatibilité Navigateur",
          browserDescription:
            "JUHUU WebApp fonctionne parfaitement sur tous les navigateurs modernes, sans plugins ni extensions requis. Ouvrez simplement votre navigateur et commencez à utiliser notre plateforme immédiatement.",
          browsers: ["Chrome", "Safari", "Firefox", "Edge", "Opera"],
          deviceHeading: "Compatibilité Appareil",
          deviceDescription:
            "Que vous soyez sur un ordinateur de bureau, un ordinateur portable, une tablette ou un smartphone, JUHUU WebApp s'adapte à la taille de votre écran et offre une expérience utilisateur optimale.",
          devices: ["Ordinateur de bureau", "Ordinateur portable", "Tablette", "iPhone", "Appareils Android"],
          openWebApp: "Ouvrir JUHUU WebApp",
          contactSales: "Contacter les Ventes",
          noDownloads: "Aucun téléchargement ou installation requis",
        },
      },
      heroDescription:
        "JUHUU connecte la technologie, l'infrastructure et les services publics via notre puissante plateforme web. Accédez à notre écosystème complet directement dans votre navigateur—aucun téléchargement requis. Gérez les services de mobilité, d'infrastructure intelligente et de services publics depuis n'importe où, sur n'importe quel appareil.",
      emailPlaceholder: "Adresse e-mail",
      getStarted: "Commencer",
      webAppFeatures: [
        {
          title: "Accès Basé sur Navigateur",
          description:
            "Accédez à toutes les fonctionnalités directement depuis votre navigateur sans télécharger de logiciel",
        },
        {
          title: "Plateforme Sécurisée",
          description:
            "Sécurité de niveau entreprise avec connexions cryptées et protection des données",
        },
        {
          title: "Analyses en Temps Réel",
          description:
            "Surveillez l'utilisation et les performances avec des tableaux de bord et rapports complets",
        },
      ],
      webPlatformTag: "Plateforme Web",
      webPlatformTitle: "Gestion de Mobilité Puissante dans Votre Navigateur",
      webPlatformDescription:
        "Notre JUHUU WebApp offre des fonctionnalités puissantes optimisées pour ordinateurs de bureau et portables. Gérez l'ensemble de votre écosystème de mobilité depuis une seule fenêtre de navigateur.",
      featureCard1Title: "Plateforme de Niveau Entreprise",
      featureCard1Description:
        "Construite pour l'échelle et la fiabilité, notre plateforme web gère des millions de transactions avec 99,9% de disponibilité et une sécurité de niveau entreprise.",
      featureCard1List: [
        "Architecture haute disponibilité",
        "Stockage de données crypté",
        "Audits de sécurité réguliers",
      ],
      featureCard2Title: "Analyses Puissantes",
      featureCard2Description:
        "Obtenez des insights plus profonds avec des tableaux de bord analytiques complets. Suivez les schémas d'utilisation, surveillez les métriques de performance et prenez des décisions basées sur les données.",
      featureCard2List: [
        "Visualisation de données en temps réel",
        "Outils de reporting personnalisés",
        "Analyses prédictives",
      ],
      featureCard3Title: "Intégration Transparente",
      featureCard3Description:
        "Connectez-vous à vos systèmes existants et services tiers. Notre architecture API ouverte assure la compatibilité avec votre pile technologique.",
      featureCard3List: [
        "Architecture API RESTful",
        "Support de webhooks",
        "Connecteurs personnalisés",
      ],
      userExperienceTag: "Expérience Utilisateur",
      bookingTitle: "Expérience de Réservation Fluide",
      bookingDescription:
        "De la découverte à l'utilisation en quelques clics seulement - voyez comment vos clients peuvent facilement accéder à vos services via JUHUU WebApp",
      featuresTag: "Fonctionnalités",
      featuresTitle: "Plateforme Web Complète",
      featuresDescription:
        "Notre JUHUU WebApp offre une suite complète d'outils pour gérer les services de mobilité, l'infrastructure et les services publics",
      customInterfaceTag: "Interface Personnalisable",
      customInterfaceTitle: "Votre Marque, Notre Technologie",
      customInterfaceDescription:
        "JUHUU permet aux organisations d'intégrer de manière transparente leur propre identité d'entreprise dans la plateforme web. Maintenez votre identité de marque tout en exploitant notre technologie puissante.",
      becomePartner: "Devenir Partenaire",
      partnerDescription: "Intégrez vos services dans notre réseau en croissance",
      customInterfaces: [
        {
          title: "Image de Marque Personnalisée",
          description:
            "Les organisations peuvent intégrer leur propre logo, couleurs et design dans la plateforme web.",
          features: [
            "Incorporez votre propre logo",
            "Appliquez les couleurs de votre marque",
            "Personnalisez les noms de produits",
            "Expérience de marque cohérente",
          ],
        },
        {
          title: "Tarification Sur Mesure",
          description:
            "Conception de tarifs flexible et catégorisation de produits selon vos besoins.",
          features: [
            "Structures tarifaires personnalisées",
            "Réductions et offres spéciales",
            "Facturation basée sur le temps ou l'utilisation",
            "Options de tarification flexibles",
          ],
        },
        {
          title: "Intégration Fluide",
          description:
            "Intégration complète dans les identités de marque existantes comme ÖBB Bike.",
          features: [
            "Cohérence avec les autres canaux de marque",
            "Interface familière pour les clients",
            "Étiquettes de fonctionnalités personnalisables",
            "Vos propres conditions d'utilisation",
          ],
        },
      ],
      liveDemoTag: "Démo en Direct",
      liveDemoTitle: "Explorez JUHUU WebApp en Action",
      liveDemoDescription:
        "Découvrez les emplacements, opérateurs et services disponibles en temps réel. Voyez comme il est facile de trouver et réserver des services de mobilité sur notre réseau en croissance.",
      mapHeading: "Expérience de Carte Interactive",
      mapDescription:
        "Parcourez notre carte interactive pour voir tous les services disponibles dans votre région. Explorez différents opérateurs, emplacements et options de mobilité en un seul endroit.",
      statProviders: "Fournisseurs de services",
      statBookingTime: "Temps de réservation moyen",
      statAvailability: "Disponibilité du service",
      partners: "Déjà en partenariat avec nous",
      joinOperator: "Rejoignez-nous en tant qu'opérateur",
      openWebApp: "Ouvrir JUHUU WebApp",
      viewCustomInterface: "Voir l'interface personnalisée",
    },
    smartCity: {
      heroTitle: "La Plateforme Ville Intelligente",
      heroHighlight: "Complète",
      featuredBadge: "En Vedette",
      heroHeadingMain: "Villes Intelligentes",
      heroHeadingHighlight: "Réinventées",
      heroDescription:
        "Transformez l'infrastructure urbaine en un écosystème unifié et intelligent. Déployez, gérez et développez des services de ville intelligente avec une fiabilité de niveau entreprise.",
      dashboardTitle: "Tableau de Bord Ville Intelligente",
      serviceBikeParking: "Stationnement à Vélos",
      serviceBikeParkingCount: "1 247 actifs",
      serviceEvCharging: "Recharge VE",
      serviceEvChargingCount: "89 stations",
      serviceSmartParking: "Stationnement Intelligent",
      serviceSmartParkingCount: "2 156 places",
      serviceCitizenApp: "Application Citoyenne",
      serviceCitizenAppCount: "45K utilisateurs",
      unifiedPlatformTitle: "Plateforme Unifiée",
      unifiedPlatformSubtitle: "Tous les services, un tableau de bord",
      usageGrowth: "Croissance d'Utilisation",
      badgeEnterprise: "Plateforme Entreprise",
      overviewDescription:
        "JUHUU est conçu pour aider les villes à unifier leurs services de mobilité urbaine et d'infrastructure, réduisant la complexité d'intégration et offrant des expériences citoyennes fluides.",
      cityAdminTitle: "Pour les Administrateurs de Ville",
      cityAdminDesc:
        "Centralisez tous les actifs urbains connectés—stationnement à vélos, hubs de trottinettes, chargeurs VE et places de parking—sous une plateforme unifiée avec insights en temps réel et facturation citoyenne automatisée.",
      cityAdminBullet: "Gestion en Temps Réel",
      innovationTeamsTitle: "Pour les Équipes d'Innovation",
      innovationTeamsDesc:
        "Lancez de nouveaux services de ville intelligente en quelques semaines avec notre plateforme modulaire. Du pilote au déploiement à l'échelle de la ville avec des intégrations préfabriquées pour l'infrastructure urbaine populaire.",
      innovationTeamsBullet: "Déploiement Rapide",
      citizensTitle: "Pour les Citoyens",
      citizensDesc:
        "Accédez à tous les services de la ville via une application familière. Réservez un stationnement, déverrouillez des vélos, rechargez des véhicules et payez de manière transparente—tout en permettant à la ville d'obtenir de précieuses données d'utilisation.",
      citizensBullet: "Expérience Unifiée",
      processBadge: "Processus de Mise en Œuvre",
      processTitlePrefix: "Comment JUHUU",
      processTitleHighlight: "Fonctionne",
      processDescription:
        "De la consultation initiale au déploiement complet, notre processus rationalisé garantit le lancement réussi de votre initiative de ville intelligente.",
      step1Title: "Découverte & Planification",
      step1Desc:
        "Nous analysons votre infrastructure existante, identifions les opportunités d'intégration et créons une feuille de route personnalisée pour votre transformation de ville intelligente.",
      step1Duration: "1-2 semaines",
      step2Title: "Mise en Œuvre Pilote",
      step2Desc:
        "Commencez par un programme pilote ciblé pour valider la solution, recueillir les retours citoyens et démontrer le ROI avant un déploiement plus important.",
      step2Duration: "3-4 semaines",
      step3Title: "Déploiement Complet",
      step3Desc:
        "Élargissez le pilote réussi à l'ensemble de votre ville avec notre méthodologie de déploiement éprouvée, formation complète et support continu.",
      step3Duration: "3-6 mois",
      applicationsBadge: "Avantages de la Plateforme",
      applicationsTitlePrefix: "Pourquoi Choisir",
      applicationsTitleHighlight: "JUHUU",
      applicationsDescription:
        "JUHUU offre des économies de temps significatives et une réduction des coûts par rapport aux approches de développement traditionnelles.",
      feature1Title: "Gestion de Services Unifiée",
      feature1ImageAlt: "Gestion de Services Unifiée",
      centralizedPlatform: "Plateforme Centralisée",
      centralizedPlatformDesc:
        "Gérez tous les services de la ville—stationnement, transit, services publics—depuis un seul tableau de bord.",
      realTimeMonitoring: "Surveillance en Temps Réel",
      realTimeMonitoringDesc:
        "Suivez l'utilisation des services, identifiez les goulets d'étranglement et optimisez l'allocation des ressources avec des flux de données en direct.",
      feature2Title: "Expérience Citoyenne Fluide",
      feature2ImageAlt: "Expérience Citoyenne Fluide",
      unifiedAppAccess: "Accès App Unifié",
      unifiedAppAccessDesc:
        "Les citoyens accèdent à tous les services—stationnement, transit, paiements—via une application unique et intuitive.",
      personalizedServices: "Services Personnalisés",
      personalizedServicesDesc:
        "Adaptez les offres de services selon les préférences citoyennes, la localisation et le comportement passé.",
      feature3Title: "Mise en Œuvre Rapide",
      deploymentShort: "Déploiement en 8-12 Semaines",
      deploymentDesc:
        "De la planification au lancement en semaines, pas en mois, avec notre méthodologie de mise en œuvre.",
      prebuiltIntegrations: "Intégrations Préfabriquées",
      prebuiltIntegrationsDesc:
        "Connectez-vous à l'infrastructure existante avec un développement personnalisé minimal requis.",
      feature4Title: "Architecture Pérenne",
      openApis: "APIs Ouvertes",
      openApisDesc:
        "Intégrez facilement de nouveaux services et technologies au fur et à mesure que votre ville évolue.",
      scalableInfrastructure: "Infrastructure Évolutive",
      scalableInfrastructureDesc:
        "Construite pour gérer les populations urbaines croissantes et l'expansion des offres de services.",
      caseStudiesBadge: "Histoires de Succès",
      trustedBy: "Fait confiance par",
      trustedByHighlight: "Villes Leaders",
      trustedByDesc: "Implémentations réelles dans les villes européennes",
      case1Title: "Grande Ville Allemande",
      case1Subtitle: "1 500+ Places de Stationnement à Vélos",
      case1Desc:
        "Gestion centralisée de plus de 1 500 places de stationnement à vélos de plusieurs fournisseurs sous une plateforme JUHUU unifiée, offrant une visibilité et un contrôle complets.",
      case1Quote:
        "\"JUHUU a transformé la façon dont nous gérons notre infrastructure de stationnement à vélos. La plateforme unifiée nous donne une visibilité complète sur tous les fournisseurs.\"",
      case1Author: "— Directeur de la Mobilité",
      case2Title: "Municipalité Européenne",
      case2Subtitle: "800 Supports Numérisés",
      case2Desc:
        "Équipement de 800 supports à vélos analogiques avec des serrures Bluetooth et des capacités de réservation en temps réel via JUHUU, atteignant des taux d'utilisation 45% plus élevés.",
      case2Quote:
        "\"La solution de retrofit était rentable et a fourni des résultats immédiats. Les citoyens adorent l'expérience de réservation fluide.\"",
      case2Author: "— Responsable des Transports",
    },
    pricing: {
      customInterfaces: [
        {
          title: "Custom Branding",
          description:
            "Providers can integrate their own logo, colors, and design into the app.",
          features: [
            "Incorporate your own logo",
            "Apply your brand colors",
            "Customize product names",
            "Consistent brand experience",
          ],
        },
        {
          title: "Tailored Pricing",
          description:
            "Flexible tariff design and product categorization according to your needs.",
          features: [
            "Custom tariff structures",
            "Special discounts and offers",
            "Time-based or usage-based billing",
            "Flexible pricing options",
          ],
        },
        {
          title: "Seamless Integration",
          description:
            "Complete integration into existing brand identities like ÖBB Bike.",
          features: [
            "Consistency with other brand channels",
            "Familiar interface for customers",
            "Customizable feature labels",
            "Your own terms of use",
          ],
        },
      ],
      features: [
        {
          title: "Mobility",
          description:
            "Comprehensive mobility solutions for urban transportation needs.",
          benefits: [
            "Seamless integration with public transport",
            "Real-time tracking and notifications",
            "Flexible payment options",
            "Multi-modal journey planning",
          ],
        },
        {
          title: "Infrastructure",
          description:
            "Smart infrastructure management for cities and businesses.",
          benefits: [
            "IoT-enabled monitoring systems",
            "Predictive maintenance",
            "Resource optimization",
            "Environmental impact tracking",
          ],
        },
        {
          title: "Utilities",
          description:
            "Efficient utility management solutions for modern needs.",
          benefits: [
            "Smart metering integration",
            "Usage analytics and insights",
            "Automated billing systems",
            "Consumption optimization",
          ],
        },
        {
          title: "Payments",
          description:
            "Secure and flexible payment processing for all services.",
          benefits: [
            "Multiple payment methods",
            "Subscription management",
            "Automated invoicing",
            "Revenue sharing capabilities",
          ],
        },
        {
          title: "Analytics",
          description: "Powerful analytics tools to drive business decisions.",
          benefits: [
            "Real-time dashboards",
            "Custom reporting",
            "Predictive analytics",
            "User behavior insights",
          ],
        },
        {
          title: "Integration",
          description:
            "Seamless integration with existing systems and third-party services.",
          benefits: [
            "Open API architecture",
            "Custom connectors",
            "Legacy system compatibility",
            "Plug-and-play modules",
          ],
        },
        {
          title: "Security",
          description: "Enterprise-grade security for all platform components.",
          benefits: [
            "End-to-end encryption",
            "Multi-factor authentication",
            "Regular security audits",
            "Compliance with global standards",
          ],
        },
      ],
    },
    useCases: {
      heroTitle: "Cas d'Usage",
      heroDescription:
        "Découvrez comment JUHUU peut être utilisé pour différents cas d'usage pour atteindre vos objectifs commerciaux.",
      designYourOwnTitle: "Concevez Votre Propre Cas d'Usage",
      designYourOwnDescription:
        "Avec notre boîte à outils modulaire, vous pouvez numériser n'importe quelle idée en quelques jours—du partage de vélos et trottinettes aux plateformes de stationnement intelligent.",
      bikeParkingTitle: "Stationnement à Vélos",
      bikeParkingDescription:
        "Notre solution complète de stationnement à vélos offre aux fabricants et opérateurs un système de gestion complet avec contrôles d'accès et traitement des paiements.",
      bikeSharingTitle: "Partage de Vélos",
      bikeSharingDescription:
        "Lancez et gérez un service complet de partage de vélos avec notre solution de bout en bout pour applications utilisateur, tableaux de bord opérateur et paiements.",
      learnMore: "En savoir plus →",
    },
  },
  components: {

    // TODO(i18n): French translations pending — English fallback copy below.
    nav: {
      products: {
        app: "App",
        appSub: "For end users",
        dashboard: "Dashboard",
        dashboardSub: "For operators",
        locking: "Locking systems",
        lockingSub: "Hardware & access",
      },
      industries: {
        bikeParking: "Bike parking",
        bikeRental: "Bike rental",
        other: "Other use cases",
      },
      industriesLabel: "Industries",
      productLabel: "Product",
      companyLabel: "Company",
      references: "References",
      about: "About",
      bookDemo: "Book demo",
      getTheApp: "Get the app",
    },
    siteFooter: {
      tagline:
        "The all-in-one platform for the sharing economy — one app, one dashboard, smart locking systems.",
      legalLabel: "Legal",
      imprint: "Imprint",
      privacy: "Privacy",
      cookies: "Cookies",
      saasAgreement: "Global SaaS agreement",
      termsOfService: "Global terms of service",
      cookieSettings: "Cookie settings",
      rightsReserved: "All rights reserved.",
      trademarks:
        "Apple, the Apple logo, iPhone and iPad are trademarks of Apple Inc., registered in the U.S. and other countries. App Store is a service mark of Apple Inc. Google Play and the Google Play logo are trademarks of Google LLC. All other trademarks are the property of their respective owners.",
    },
        useCases: {
          title: "Solutions pour Tous les Besoins",
          description:
            "Découvrez comment JUHUU s'adapte à différents secteurs et cas d'usage",
          designModel: {
            title: "Concevez Votre Modèle d'Affaires",
            description:
              "JUHUU fournit une boîte à outils complète pour les fabricants et opérateurs afin de créer leurs propres modèles d'affaires uniques...",
            tags: [
              "Composants Modulaires",
              "Intégration Flexible",
              "Modèles de Revenus Personnalisés",
              "Déploiement Rapide",
            ],
            cta: "Explorer les Possibilités",
            imgAlt: "Modèle d'Affaires Personnalisé",
          },
          bikeParking: {
            title: "Stationnement à Vélos",
            description:
              "Notre solution complète de stationnement à vélos sert à la fois les fabricants et les opérateurs...",
            tags: [
              "Intégration Matérielle",
              "Gestion des Accès",
              "Analyses d'Utilisation",
              "Modèles d'Abonnement",
            ],
            cta: "Découvrir le Stationnement à Vélos",
            imgAlt: "Solution de Stationnement à Vélos",
          },
          smartCity: {
            title: "Ville Intelligente",
            description:
              "JUHUU équipe les villes d'une boîte à outils complète pour devenir des villes intelligentes, intégrant tous leurs services dans une plateforme centrale",
            tags: ["Gestion de Flotte", "Applications Utilisateur", "Maintenance", "Analyses"],
            cta: "Découvrir la Ville Intelligente",
            imgAlt: "Partage de Vélos",
          },
        },
        targetGroups: {
          title: "Renforcer Votre Écosystème Numérique",
          description:
            "Notre plateforme SaaS modulaire fournit des solutions sur mesure pour différents acteurs de l'espace mobilité et infrastructure",
          oems: {
            title: "Pour les Fabricants",
            description:
              "Intégrez votre matériel dans notre écosystème et élargissez votre portée de marché. Notre plateforme fournit des outils pour numériser vos produits, surveiller les performances et créer de nouveaux flux de revenus.",
            features: {
              digitalTwins: {
                title: "Jumeaux Numériques",
                desc: "Créez des répliques virtuelles de votre matériel",
              },
              integrationOptions: {
                title: "Options d'Intégration",
                desc: "Solutions sans code, low-code et expertes",
              },
              marketplace: {
                title: "Marketplace",
                desc: "Présentez vos produits aux opérateurs",
              },
              analytics: {
                title: "Analyses",
                desc: "Obtenez des insights à partir des données d'utilisation",
              },
            },
            imageAlt: "Appareils fabricants",
          },
          operators: {
            title: "Pour les Opérateurs",
            description:
              "Créez, lancez et développez rapidement vos opérations numériques avec nos blocs de construction modulaires. Créez des solutions sur mesure pour la mobilité partagée, l'infrastructure intelligente et les services publics sans repartir de zéro.",
            features: {
              modularPlatform: {
                title: "Plateforme Modulaire",
                desc: "Mélangez et associez les composants selon vos besoins",
              },
              dashboard: {
                title: "Tableau de Bord",
                desc: "Surveillez et gérez vos opérations",
              },
              billing: {
                title: "Facturation",
                desc: "Gérez les paiements et les abonnements",
              },
              userApps: {
                title: "Applications Utilisateur",
                desc: "Offrez des expériences client fluides",
              },
            },
            imageAlt: "Tableau de bord opérateur",
          },
        },
        productCategories: {
          coreInfrastructure: {
            tag: "Infrastructure de Base & Outils Développeur",
            title: "Construire les fondations de l'innovation",
            description:
              "Cette catégorie constitue l'épine dorsale de l'écosystème JUHUU, fournissant une infrastructure essentielle et des outils pour développeurs permettant un développement rapide, une intégration sécurisée et des opérations évolutives pour les entreprises de mobilité partagée et d'infrastructure intelligente. Elle donne aux opérateurs et fabricants une base solide pour innover et déployer des solutions efficacement.",
            identity: {
              title: "JUHUU Identity",
              description:
                "Service d'authentification centralisé offrant email/mot de passe, connexion Google/Apple et vérification optionnelle de documents d'identité.",
              cta: "Solutions d'Identité",
              alt: "JUHUU Identity",
            },
            docs: {
              title: "JUHUU Docs",
              description:
                "Une base de connaissances complète où les fabricants et opérateurs téléchargent des manuels, spécifications techniques et politiques.",
              cta: "Centre de Documentation",
              alt: "JUHUU Docs",
            },
            specialDevelopment: {
              title: "JUHUU Développement Spécialisé",
              description:
                "Un service d'intégration sur mesure pour les cas d'usage complexes, avec des systèmes personnalisés intégrés à la plateforme.",
              cta: "Solutions Personnalisées",
              alt: "JUHUU Développement Spécialisé",
            },
            digitalTwins: {
              title: "JUHUU Jumeaux Numériques",
              description:
                "Un hub unifié créant des répliques virtuelles des appareils intégrés, permettant aux opérateurs de surveiller l'état et la santé.",
              cta: "Plateforme Jumeau Numérique",
              alt: "JUHUU Jumeaux Numériques",
            },
            developerToolsLabel: "Outils Développeur",
            bigImageAlt: "Infrastructure de Base & Outils Développeur",
          },
          userAccess: {
            tag: "Accès Utilisateur & Interfaces de Réservation",
            title: "Accès fluide, à tout moment, partout",
            description:
              "Cette catégorie se concentre sur la fourniture d'interfaces conviviales qui simplifient la réservation et l'accès aux services de mobilité et d'infrastructure sur plusieurs plateformes.",
            app: {
              title: "JUHUU App",
              description:
                "Une application native iOS/Android permettant aux utilisateurs de trouver, réserver et accéder à des services comme les vélos, trottinettes et casiers via une interface unique, avec marque blanche pour les opérateurs.",
              cta: "Fonctionnalités de l'App",
              label: "Application Mobile",
              altIcon: "JUHUU App",
              altImage: "Application Mobile JUHUU",
              appStoreAlt: "Télécharger sur l'App Store",
              googlePlayAlt: "Disponible sur Google Play",
            },
            webApp: {
              title: "JUHUU Web App",
              description:
                "Une alternative basée navigateur à l'application JUHUU, fournissant des fonctionnalités complètes de réservation et de déverrouillage pour les utilisateurs occasionnels, avec un ensemble de fonctionnalités optimisé pour encourager l'adoption de l'application native.",
              cta: "Plateforme Web App",
              altIcon: "JUHUU Web App",
            },
            map: {
              title: "JUHUU Map",
              description:
                "Une carte interactive regroupant tous les emplacements de services, offrant des filtres personnalisables et la marque de l'opérateur, avec des options d'intégration iframe pour les plateformes externes moyennant un coût supplémentaire.",
              cta: "Carte Interactive",
              altIcon: "JUHUU Map",
            },
          },
          commerce: {
            tag: "Commerce & Monétisation",
            title: "Transformer les transactions en croissance",
            description:
              "Des outils puissants pour gérer les paiements, créer de nouveaux flux de revenus et construire des modèles d'affaires durables. Nos solutions commerciales vous aident à monétiser les services et maximiser la rentabilité.",
            billing: {
              title: "JUHUU Billing",
              tagline: "Infrastructure de paiement complète",
              description:
                "Un hub financier complet gérant les paiements, la génération automatique de factures, les versements aux opérateurs et la configuration des tarifs. Construit sur l'infrastructure Stripe avec intégration en temps réel au tableau de bord.",
              stats: {
                success: "Taux de réussite des paiements",
                speed: "Traitement plus rapide",
                revenue: "Augmentation des revenus",
              },
              cta: "En savoir plus sur la Facturation",
              altIcon: "JUHUU Billing",
              altImage: "Tableau de bord JUHUU Billing",
            },
            marketplace: {
              title: "JUHUU Marketplace",
              description:
                "Un canal de vente où les fabricants listent des appareils et services certifiés et intégrés à la plateforme, permettant aux opérateurs de parcourir et adopter des solutions facilement.",
              cta: "Explorer le Marketplace",
              altIcon: "JUHUU Marketplace",
            },
            revenueShare: {
              title: "JUHUU Partage de Revenus",
              comingSoon: "Prochainement",
              description:
                "Un programme à venir de type affiliation récompensant les opérateurs avec 15% des frais de plateforme pour les références d'utilisateurs, conçu pour réduire les coûts d'acquisition et stimuler la croissance.",
              altIcon: "JUHUU Partage de Revenus",
            },
            plusSubscriptions: {
              title: "Abonnements Plus",
              comingSoon: "Prochainement",
              description:
                "Créez des niveaux d'abonnement premium pour vos services avec des cycles de facturation flexibles, des périodes d'essai et des avantages spéciaux pour les abonnés.",
              altIcon: "Abonnement Plus",
            },
            testimonial: {
              quote:
                "\"Le système de facturation de JUHUU a transformé nos opérations financières. Nous avons réduit le temps de traitement des paiements de 60% et augmenté l'efficacité de collecte des revenus de 35% depuis sa mise en œuvre.\"",
              name: "Thomas Weber",
              position: "Directeur Financier chez Urban Mobility Solutions",
              altPortrait: "Portrait Client",
            },
            ctaTitle: "Prêt à transformer votre modèle de revenus ?",
            ctaButton: "Contacter les Ventes",
          },
          operations: {
            tag: "Opérations et Surveillance",
            title: "Contrôler et optimiser vos opérations",
            description:
              "Cette catégorie fournit des outils avancés pour surveiller, gérer et optimiser les opérations en temps réel. Destinée aux opérateurs et fabricants, elle offre une supervision complète des actifs, une maintenance prédictive et des analyses de performance, aidant à minimiser les temps d'arrêt et améliorer l'efficacité.",
            dashboard: {
              title: "JUHUU Dashboard",
              description:
                "Le centre de commande central pour les opérateurs et fabricants, offrant une surveillance en temps réel des revenus, du statut des appareils, de l'utilisation et des interventions de support. Obtenez des informations complètes sur les performances de votre entreprise avec des vues et rapports personnalisables.",
              cta: "Fonctionnalités du Tableau de Bord",
              altIcon: "Tableau de Bord",
            },
            anomalyDetection: {
              title: "JUHUU Détection d'Anomalies IA",
              comingSoon: "Prochainement",
              description:
                "Un module de maintenance de nouvelle génération utilisant le ML et LLM pour prédire les pannes, réduisant les temps d'arrêt imprévus jusqu'à 30% et les coûts de maintenance de 25%, avec alertes dans le tableau de bord. Anticipez les problèmes avant qu'ils n'impactent votre entreprise.",
              altIcon: "JUHUU Détection d'Anomalies IA",
            },
            demoTitle: "Démo du Tableau de Bord",
          },
          customerSupport: {
            tag: "Support Client",
            title: "Un support qui ne dort jamais",
            description:
              "Cette catégorie fournit des solutions de support continues et intelligentes pour améliorer les expériences utilisateur et opérateur. Tirant parti de l'IA et de l'expertise humaine, elle fournit une assistance immédiate et escalade les problèmes complexes, garantissant une satisfaction élevée et réduisant les coûts de support.",
            buddy: {
              title: "JUHUU Buddy",
              description:
                "Un chatbot alimenté par l'IA formé sur JUHUU Docs, intégré sur toutes les plateformes pour répondre aux questions et exécuter des tâches comme la création d'emplacements ou la mise à jour de tarifs. Disponible 24/7, il fournit un support instantané pour les demandes courantes et les tâches opérationnelles.",
              bullets: [
                "Formé sur votre documentation",
                "Effectue des tâches opérationnelles automatiquement",
                "Disponible sur toutes les plateformes",
              ],
              cta: "Rencontrer JUHUU Buddy",
              overlay: "Propulsé par l'IA",
              altIcon: "JUHUU Buddy",
              altImage: "JUHUU Buddy",
            },
            customerSupport: {
              title: "JUHUU Support Client",
              description:
                "Une suite de support multimodale à venir avec numéros de téléphone personnalisés, contexte conscient de l'interface, escalades automatisées et réponses spécifiques aux opérateurs depuis Docs. Cette solution complète fournira des expériences de support fluides sur tous les canaux.",
              bullets: [
                "Support multicanal (chat, téléphone, e-mail)",
                "Assistance contextuelle",
                "Escalade intelligente vers des agents humains",
              ],
              cta: "Solutions de Support",
              overlay: "Prochainement",
              altIcon: "JUHUU Support Client",
              altImage: "JUHUU Support Client",
            },
          },
        },
    cta: {
      ready: "Prêt à transformer votre entreprise ?",
      join: "Rejoignez des centaines d'entreprises utilisant déjà JUHUU pour créer, lancer et développer leurs solutions de mobilité et d'infrastructure.",
      launch: "Lancez votre solution en semaines, pas en mois",
      scale: "Évoluez de manière transparente à mesure que votre entreprise se développe",
      pay: "Ne payez que ce que vous utilisez avec notre approche modulaire",
      start: "Commencer aujourd'hui",
      fullName: "Nom Complet",
      workEmail: "E-mail Professionnel",
      company: "Entreprise",
      message: "Message",
      namePlaceholder: "Entrez votre nom",
      emailPlaceholder: "vous@entreprise.com",
      companyPlaceholder: "Nom de votre entreprise",
      messagePlaceholder: "Comment pouvons-nous vous aider ?",
      submit: "Contacter les Ventes",
      wait: "Veuillez patienter...",
      sent: "Envoyé avec succès !",
      error: "Erreur, cliquez pour réessayer.",
      terms: "Conditions d'Utilisation",
      privacy: "Politique de Confidentialité",
      consent: "En soumettant ce formulaire, vous acceptez nos",
      and: "et",
    },
    navbar: {
      logoAlt: "Logo JUHUU",
      badgeComingSoon: "Prochainement",
      buttons: {
        products: "Produits",
        solutions: "Cas d'Usage",
        developers: "Développeurs",
        pricing: "Tarification",
        signIn: "Se connecter",
        contactSales: "Contacter les ventes",
      },
      categories: {
        core: "Infrastructure de Base & Outils Développeur",
        userAccess: "Accès Utilisateur & Interfaces de Réservation",
        commerce: "Commerce & Monétisation",
        operations: "Opérations et Surveillance",
        customerSupport: "Support Client",
        comingSoonTitle: "Prochainement",
        userGroups: "Groupes d'Utilisateurs",
        useCases: "Cas d'Usage",
      },
      products: {
        digitalTwins: {
          title: "Jumeaux Numériques",
          desc: "Réplications virtuelles",
          alt: "Jumeaux Numériques",
        },
        docs: {
          title: "Docs",
          desc: "Gestion de la documentation",
          alt: "Docs",
        },
        identity: {
          title: "Identity",
          desc: "Gestion d'identité",
          alt: "Identity",
        },
        plugIn: {
          title: "Plug In",
          desc: "Intégrations extensibles",
          alt: "Plug In",
        },
        specialDevelopment: {
          title: "Développement Spécialisé",
          desc: "Développement personnalisé",
          alt: "Développement Spécialisé",
        },
        strata: {
          title: "Strata",
          desc: "Plateforme d'analyse de données",
          alt: "Strata",
        },
        app: {
          title: "App",
          desc: "Applications mobiles",
          alt: "App",
        },
        map: {
          title: "Map",
          desc: "Services basés sur la localisation",
          alt: "Map",
        },
        webApp: {
          title: "WebApp",
          desc: "Développement d'applications web",
          alt: "WebApp",
        },
        whitelabel: {
          title: "Whitelabel",
          desc: "Solutions en marque blanche",
          alt: "Whitelabel",
        },
        billing: {
          title: "Billing",
          desc: "Facturation",
          alt: "Billing",
        },
        marketplace: {
          title: "Marketplace",
          desc: "Plateforme pour vendeurs",
          alt: "Marketplace",
        },
        plusSubscriptions: {
          title: "Abonnements Plus",
          desc: "Abonnements premium",
          alt: "Abonnements Plus",
        },
        revenueShare: {
          title: "Partage de Revenus",
          desc: "Partage des revenus",
          alt: "Partage de Revenus",
        },
        anomalyDetection: {
          title: "Détection d'Anomalies",
          desc: "Détection d'irrégularités",
          alt: "Détection d'Anomalies",
        },
        dashboard: {
          title: "Dashboard",
          desc: "Visualisation de données business",
          alt: "Dashboard",
        },
        advancedSupport: {
          title: "Support Avancé",
          desc: "Support client avancé",
          alt: "Support Avancé",
        },
        buddy: {
          title: "Buddy",
          desc: "Assistant de support personnel",
          alt: "Buddy",
        },
      },
      comingSoonList: {
        affiliateLinks: "Liens d'Affiliation",
        aiRouting: "Routage IA",
        integratedBookables: "Services Réservables Intégrés",
        plusSubscription: "Abonnement Plus",
        referalLinks: "Liens de Parrainage",
        tenderService: "Service d'Appel d'Offres",
      },
      userGroups: {
        oems: "Pour les Fabricants",
        operators: "Pour les Opérateurs",
        users: "Pour les Utilisateurs",
      },
      useCases: {
        designYourUseCase: "Concevez votre Cas d'Usage",
        smartCity: "Ville Intelligente",
        bikeParking: "Stationnement à Vélos",
        bikeSharing: "Partage de Vélos",
        scooterSharing: "Partage de Trottinettes",
      },
      developers: {
        documentation: "Documentation",
        apiReference: "Référence API",
        libraries: "Bibliothèques",
      },
    },
    footer: {
      altLogo: "Logo JUHUU",
      social: {
        linkedin: "LinkedIn",
        youtube: "YouTube",
        instagram: "Instagram",
        facebook: "Facebook",
      },
      contactUs: "Contactez-nous",
      general: "Général",
      phone: "+43 660 9919 009",
      email: "office@juhuu.app",
      addressHeading: "Adresse pour réunions & expéditions :",
      address: {
        line1: "Lassallestraße 9,",
        line2: "1020 Vienne,",
        line3: "Autriche",
      },
      important: "Important",
      developers: "Développeurs",
      globalTerms: "Conditions Générales Mondiales",
      agreement: "Accord",
      globalSaas: "Accord SaaS Mondial",
      privacy: "Confidentialité",
      imprint: "Mentions Légales",
      cookiePolicy: "Politique de Cookies",
      juhuuApp: "Application JUHUU",
      appStoreAlt: "Télécharger sur l'App Store",
      googlePlayAlt: "Disponible sur Google Play",
      juhuuWebApp: "JUHUU WebApp",
      openWebApp: "Ouvrir WebApp",
      copyright:
        "© 2025 Copyright: JUHUU Bikebox GmbH. Apple, le logo Apple, iPhone et iPad sont des marques commerciales d'Apple Inc., déposées aux États-Unis et dans d'autres pays. App Store est une marque de service d'Apple Inc. Google Play et le logo Google Play sont des marques commerciales de Google LLC. Toutes les autres marques commerciales appartiennent à leurs propriétaires respectifs.",
      termsOfService: "Conditions d'Utilisation",
      privacyPolicy: "Politique de Confidentialité",
      cookieSettings: "Paramètres des Cookies",
      sitemap: "Plan du Site",
    },
    sendInquiry: {
      emailPlaceholder: "Adresse e-mail",
      submit: "Envoyer une demande",
      wait: "Veuillez patienter...",
      sent: "Envoyé avec succès !",
      error: "Erreur, cliquez pour réessayer.",
    },
    page: {
      navItems: {
        useCases: "Cas d'Usage",
        app: "App",
        dashboard: "Dashboard",
        kit: "Kit de Numérisation",
        marketplace: "Marketplace",
        pricing: "Tarification",
      },
      close: "Fermer",
    },
  },
  bikeParking: {
    hero: {
      forCities: "Pour les municipalités & villes",
      description:
        "JUHUU révolutionne le stationnement à vélos dans votre municipalité. Notre plateforme numérique transforme les installations de stationnement existantes et nouvelles en actifs intelligents générateurs de revenus – 70% plus rapide à déployer et jusqu'à 80% moins cher.",
      emailPlaceholder: "Votre adresse e-mail",
      ctaButton: "Consultation gratuite",
      fastImplementation: "Mise en œuvre rapide",
      gdprCompliant: "Conforme RGPD",
      costEfficient: "Rentable",
    },
    payment: {
      magazineTitle: "Abstraction Magazine",
      magazinePrice: "19 € par mois",
      applePay: "Payer",
      orCard: "Ou payer par carte",
      emailPlaceholder: "E-mail",
      cardDetails: "Détails de la carte",
      cardNumber: "Numéro",
      expire: "MM/AA",
      cvc: "CVC",
      countryLabel: "Pays/Région",
      countryUs: "États-Unis",
      zip: "Code postal",
      pay: "Payer",
    },
    stats: {
      today: "Aujourd'hui",
      week: "Cette semaine",
      utilization: "Utilisation",
      yesterday: "Hier",
      now: "Aujourd'hui, 14:00",
      title: "Utilisation du stationnement à vélos",
    },
    cityBenefits: {
      optimized: "Optimisé pour les municipalités",
      title: "Pourquoi les villes choisissent JUHUU",
      description:
        "Notre plateforme fournit aux villes et municipalités une solution unifiée pour le stationnement à vélos moderne",
      main: {
        unifiedTitle: "Expérience citoyenne unifiée",
        unifiedDesc: "Une app pour tous les fournisseurs de stationnement à vélos de votre ville",
        dataTitle: "Décisions basées sur les données",
        dataDesc: "Données en temps réel pour optimiser votre infrastructure cyclable",
        costTitle: "Efficacité des coûts",
        costDesc: "Jusqu'à 80% d'économies par rapport aux solutions uniques",
        fastTitle: "Mise en œuvre rapide",
        fastDesc: "Prêt en semaines au lieu de mois",
      },
      centralLabel: "Gestion centralisée",
      centralTitle: "Gestion centralisée de tous les sites de stationnement à vélos",
      central: {
        dashboardTitle: "Tableau de bord central",
        dashboardDesc: "Gérez tous les fournisseurs et emplacements via une seule plateforme",
        appTitle: "Application tout-en-un",
        appDesc:
          "Une app pour tous les services de stationnement à vélos ou de mobilité de votre ville avec design d'entreprise",
        analyticsTitle: "Analyses complètes",
        analyticsDesc:
          "Statistiques d'utilisation, occupation et tendances pour une meilleure planification urbaine",
        userTitle: "Gestion automatisée des utilisateurs",
        userDesc: "Inscription et gestion des utilisateurs en libre-service",
        billingTitle: "Facturation automatisée",
        billingDesc: "Création et envoi automatiques de factures aux utilisateurs",
        payoutTitle: "Versements automatisés",
        payoutDesc: "Versements réguliers aux opérateurs et règlement des commissions",
      },
      realtimeOverlay: "Aperçu en temps réel",
      retrofitLabel: "Retrofit",
      retrofitTitle: "Modernisez intelligemment les installations existantes",
      retrofitDesc:
        "Nous pouvons intégrer presque toutes les installations de stationnement à vélos existantes – des supports simples et casiers aux tours complexes. L'intégration se fait via API ou en équipant avec notre électronique.",
      retrofit: {
        bluetooth: "Serrures Euro Bluetooth plug-and-play",
        iot: "Systèmes de verrouillage IoT pour installations complexes",
        ready: "Prêt en quelques jours",
      },
      retrofitOverlay: "Installation facile",
      marketplaceLink: "Découvrez toute l'électronique sur le marketplace",
    },
    appWebApp: {
      experienceLabel: "Expérience utilisateur fluide",
      title: "App & web app unifiées pour tous les citoyens",
      description:
        "Offrez à vos citoyens une expérience intuitive et unifiée pour toutes les installations de stationnement à vélos de votre ville",
      overlay: "Capacité whitelabel",
      appSectionTitle: "Application JUHUU",
      appSectionDesc:
        "L'application JUHUU permet aux citoyens de trouver, réserver et utiliser toutes les installations de stationnement à vélos de votre ville via une interface unique et intuitive. Chaque opérateur obtient une interface de marque afin que les utilisateurs sachent immédiatement quand ils utilisent l'un de vos emplacements.",
      internalWhiteTitle: "Whitelabeling interne",
      internalWhiteDesc: "Image de marque individuelle pour chaque opérateur dans l'app",
      bluetoothTitle: "Déverrouillage Bluetooth",
      bluetoothDesc: "Déverrouillage sans contact des boxes et supports",
      iotTitle: "Intégration IoT",
      iotDesc: "Support pour systèmes de verrouillage contrôlés IoT et capteurs",
      externalWhiteTitle: "Whitelabeling externe",
      externalWhiteDesc:
        "Entièrement personnalisable pour correspondre au design d'entreprise de votre ville",
      moreApp: "En savoir plus sur l'Application JUHUU",
      exploreWeb: "Découvrir la WebApp",
      webLabel: "Basé sur navigateur",
      webTitle: "JUHUU WebApp",
      webDesc:
        "L'alternative basée navigateur à l'Application JUHUU est incluse par défaut. Les utilisateurs peuvent voir tous les emplacements avec disponibilité et prix en direct, les réserver et ouvrir les emplacements contrôlés mobile directement depuis le navigateur.",
      noInstallTitle: "Aucune installation nécessaire",
      noInstallDesc: "Utilisable immédiatement via n'importe quel navigateur web",
      responsiveTitle: "Design responsive",
      responsiveDesc: "Optimisé pour tous les appareils du smartphone à l'ordinateur de bureau",
      availableVia: "Disponible via :",
      testWebApp: "Tester la WebApp",
      downloadTitle: "Télécharger maintenant",
    },
    dashboard: {
      controlLabel: "Contrôle central",
      title: "Tableau de bord complet pour les municipalités",
      description:
        "Gardez une trace de toutes les installations de stationnement à vélos de votre ville avec notre puissant tableau de bord",
      deviceTitle: "Gestion des appareils",
      deviceDesc:
        "Gestion complète de tous les appareils et installations de stationnement à vélos",
      deviceBullets: [
        "Ajouter, retirer et verrouiller des appareils",
        "Aperçu de l'utilisation et du statut des appareils",
        "Ouverture à distance et mode maintenance",
      ],
      billingTitle: "Facturation",
      billingDesc: "Facturation et traitement des paiements entièrement automatisés",
      billingBullets: [
        "Facturation automatique aux utilisateurs",
        "Versements automatiques aux opérateurs",
        "Remboursements, dépôts et crédits",
      ],
      analyticsTitle: "Analyse de données",
      analyticsDesc:
        "Statistiques et rapports complets sur l'utilisation et l'occupation",
      analyticsBullets: [
        "Fonction d'export (CSV, PDF, Excel)",
        "Statistiques d'occupation et de revenus",
        "Comportement utilisateur et tendances",
      ],
      tariffLabel: "Systèmes tarifaires flexibles",
      tariffTitle: "Modèles de tarification sur mesure",
      tariffDesc:
        "Nous offrons des options tarifaires très flexibles qui peuvent être ajoutées par emplacement. Tout, du paiement à l'utilisation aux tarifs journaliers, mensuels et annuels, est librement configurable. Nous prenons également en charge l'intégration de cartes de réduction locales ou nationales pour des tarifs réduits.",
      tariffCards: {
        timeTitle: "Tarifs basés sur le temps",
        timeDesc: "Paiement à l'utilisation, jour, mois, année",
        companyTitle: "Comptes d'entreprise",
        companyDesc: "Quotas pour employés avec facturation centralisée",
        familyTitle: "Comptes familiaux",
        familyDesc: "Utilisation partagée pour les membres de la famille",
        benefitTitle: "Cartes d'avantages",
        benefitDesc: "Intégration de systèmes de réduction locaux et nationaux",
      },
      tariffOverlay: "Ajustable individuellement",
    },
    aiSupport: {
      label: "Support assisté par IA",
      title: "JUHUU Buddy - votre assistant intelligent",
      description:
        "Support 24/7 pour citoyens et administrateurs avec notre assistant alimenté par l'IA",
      chatIntro:
        "Bonjour ! Je suis JUHUU Buddy, votre assistant IA pour toutes les questions sur le stationnement à vélos. Comment puis-je vous aider aujourd'hui ?",
      chatQuestion: "Je veux savoir comment signaler un support à vélos défectueux.",
      chatAnswer:
        "Vous pouvez signaler les supports à vélos défectueux directement via l'Application JUHUU. Ouvrez l'app, sélectionnez l'emplacement et appuyez sur 'Signaler un problème'. Vous pouvez également scanner le code QR à l'emplacement et le signaler via la WebApp.",
      supportTitle: "Support assisté par IA 24/7",
      supportDesc:
        "JUHUU Buddy est un chatbot IA formé sur toute votre documentation. Intégré dans l'app, le web et le tableau de bord, il répond aux questions, effectue des tâches simples et escalade vers le support humain si nécessaire.",
      featureEverywhereTitle: "Disponible partout",
      featureEverywhereDesc:
        "Intégré dans l'app, la web app et le tableau de bord pour un support fluide",
      featureAlwaysTitle: "Disponibilité 24/7",
      featureAlwaysDesc:
        "Support en continu sans temps d'attente pour vos utilisateurs",
      featureTasksTitle: "Tâches automatisées",
      featureTasksDesc:
        "Effectue des tâches simples comme la recherche d'emplacement ou les demandes de statut",
      featureLanguagesTitle: "Multilingue",
      featureLanguagesDesc:
        "Prend en charge plusieurs langues pour les visiteurs internationaux",
      learnMore: "En savoir plus sur le support IA",
      requestDemo: "Demander une démo",
      statAnswered: "des demandes répondues automatiquement",
      statAvailability: "Disponibilité sans temps d'attente",
      statCost: "Réduction des coûts de support",
    },
    hardware: {
      ecosystemLabel: "Écosystème matériel",
      title: "Nos partenaires matériels",
      description:
        "JUHUU travaille avec les fabricants leaders pour vous fournir la meilleure sélection de matériel",
      marketplaceButton: "Découvrez tous les partenaires sur le marketplace",
      independentLabel: "Indépendant du fabricant",
      independentTitle: "Intégration indépendante du fabricant",
      independentDesc:
        "JUHUU fonctionne avec le matériel de tous les fabricants leaders. Notre plateforme ouverte vous permet de choisir le meilleur matériel pour vos besoins sans être lié à un seul fournisseur.",
      independentBullets: [
        "Serrures Bluetooth auto-alimentées sans alimentation externe",
        "Connectivité cellulaire pour contrôleurs et capteurs",
        "Systèmes alimentés par énergie solaire",
        "Modules retrofit pour installations existantes",
      ],
    },
    pricingSection: {
      heading: "TARIFICATION",
      decorativeAlt: "Arrière-plan décoratif",
      heroStart: "Débloquez",
      heroHighlight1: "Possibilités Illimitées",
      heroMid: "avec",
      heroHighlight2: "Paiement à l'Utilisation",
      heroEnd: "Tarification",
      description:
        "Pas de frais initiaux, pas de frais cachés — juste une tarification transparente qui évolue avec votre succès. Ne payez que ce que vous utilisez, quand vous l'utilisez.",
      deviceTypes: {
        iot: {
          name: "Appareils IoT",
          description:
            "Appareils avec carte SIM fournie par JUHUU. Cela inclut les serrures intelligentes, capteurs de stationnement et autre matériel connecté nécessitant une connectivité cellulaire.",
        },
        online: {
          name: "Appareils En Ligne",
          description:
            "Appareils tiers avec connectivité non fournie par JUHUU. Cela inclut le matériel partenaire, l'infrastructure existante et autres appareils connectés que vous possédez déjà.",
        },
        offline: {
          name: "Appareils Hors Ligne",
          description:
            "Places de stationnement sans contrôle direct. Cela inclut les locaux à vélos, places de parking et autres espaces gérés via la plateforme JUHUU mais sans contrôle électronique direct.",
        },
        bluetooth: {
          name: "Appareils Bluetooth",
          description:
            "Appareils Bluetooth standard fournis par JUHUU. Cela inclut les serrures Bluetooth, balises et autre matériel basé sur la proximité communiquant via technologie Bluetooth.",
        },
      },
      deviceLicenseTitle: "Licence Appareil Mensuelle",
      deviceInfo: "Ne payez que pour les appareils actifs. Les remises en volume s'appliquent automatiquement.",
      table: {
        volume: "Volume",
        price: "Prix",
        savings: "Économies",
        save: "Économisez {{savings}}%",
        basePrice: "Prix de base",
      },
      includedProducts: "Produits Inclus :",
      modules: {
        app: "Application JUHUU",
        webapp: "JUHUU Web App",
        dashboard: "Tableau de Bord JUHUU",
        marketplace: "Marketplace JUHUU",
        map: "Carte JUHUU",
        docs: "JUHUU Docs",
        billing: "Moteur de Facturation JUHUU",
      },
      hideExplanation: "Masquer l'Explication des Appareils",
      showExplanation: "Comment Fonctionne la Tarification des Appareils",
      explanationTitle: "Comment Fonctionne la Tarification des Appareils",
      explanationIntro:
        "Notre tarification est basée sur les appareils et espaces réels que vous avez en opération :",
      explanationPoints: {
        iot: "Frais mensuels pour chaque appareil avec carte SIM fournie par JUHUU (ex. 10 boxes à vélos = 10 frais d'appareil)",
        offline:
          "Pour les espaces sans contrôle direct (ex. un local à vélos avec 100 places entraînerait des frais d'appareils IoT pour chaque serrure contrôlée plus des frais d'appareils Hors Ligne pour chaque place de stationnement)",
        online:
          "Pour les appareils tiers avec connectivité non fournie par JUHUU (des frais spécifiques au fabricant peuvent s'appliquer)",
        bluetooth: "Pour les appareils Bluetooth standard fournis par JUHUU",
      },
      volumeDiscount:
        "Les remises en volume sont appliquées en fonction du nombre total d'appareils dans votre flotte entière, pas par emplacement.",
      transactionTitle: "Commission de Transaction",
      transactionInfo:
        "Commission sur chaque transaction de réservation traitée via la plateforme JUHUU. Ne payez que lorsque vous gagnez.",
      payOnlyLabel: "Ne Payez que pour les Réservations Réelles",
      payOnlyText: "La commission n'est facturée que lorsqu'une réservation réussie se produit.",
      examples: "Exemples :",
      booking: "réservation",
      fee: "Frais : {{amount}}",
      feeMax: "Frais : {{amount}} (max)",
      premiumTitle: "Services Premium",
      premiumDesc:
        "Services supplémentaires qui peuvent être achetés séparément pour améliorer votre expérience",
      comingSoon: "PROCHAINEMENT",
      premiumServices: {
        buddy: {
          name: "JUHUU Buddy",
          description:
            "Assistant alimenté par l'IA pour utilisateurs et opérateurs avec compréhension du langage naturel.",
          pricing: "Paiement à l'utilisation",
          pricingDetails: "Facturation basée sur les jetons",
        },
        identity: {
          name: "Vérification d'Identité",
          description:
            "Vérification d'identité sécurisée pour utilisateurs avec scan de documents et contrôles biométriques.",
          pricing: "2 €",
          pricingDetails: "/vérification",
        },
        support: {
          name: "Support Client Avancé",
          description:
            "Support premium avec gestionnaire de compte dédié et temps de réponse prioritaires.",
          pricing: "300-500 €",
          pricingDetails: "/opérateur + dépassement de jetons",
        },
        maintenance: {
          name: "Maintenance Prédictive",
          description:
            "Détection d'anomalies alimentée par l'IA et maintenance prédictive pour votre flotte d'appareils.",
          pricing: "1 €",
          perDevice: "/appareil",
          pricingDetails: "+ dépassement de jetons",
        },
      },
      calculatorTitle: "Calculateur de Prix",
      calculatorDesc: "Estimez vos coûts mensuels en fonction de vos besoins spécifiques",
      simulatorTitle: "Simulateur de Prix JUHUU",
      configuration: "Votre Configuration",
      deviceTypesTitle: "Types d'Appareils",
      monthlyTransactions: "Transactions Mensuelles",
      numberOfBookings: "Nombre de Réservations",
      commissionPerBooking: "Commission de 10% par réservation",
      avgBookingValue: "Valeur Moyenne de Réservation (€)",
      minMaxFee: "Frais min : 0,50 €, Frais max : 5,00 €",
      estimatedTitle: "Coût Mensuel Estimé",
      deviceLicenses: "Licences Appareil",
      devicesTotal: "appareils au total",
      transactionCommissions: "Commissions de Transaction",
      totalMonthlyCost: "Coût Mensuel Total",
      estimateDisclaimer:
        "Ceci est une estimation basée sur vos entrées. Les coûts réels peuvent varier en fonction des schémas d'utilisation, des remises en volume et d'autres facteurs. Contactez notre équipe commerciale pour un devis détaillé.",
      contactSales: "Contacter les Ventes pour un Devis Détaillé",
      note:
        "JUHUU se réserve le droit d'introduire des frais séparés pour des produits supplémentaires à l'avenir. Tous les modules non listés sous \"Plugins/Produits Premium\" sont actuellement couverts par les Licences Appareil et Commissions de Transaction.",
    },
  },
} as const;
